var items = {
  "block.minecraft.acacia_button": "Butón d'acaciu",
  "block.minecraft.acacia_door": "Puerta d'acaciu",
  "block.minecraft.acacia_fence": "Cierru d'acaciu",
  "block.minecraft.acacia_fence_gate": "Purtillu d'acaciu",
  "block.minecraft.acacia_hanging_sign": "Endicaor colganti d'acaciu",
  "block.minecraft.acacia_leaves": "Jueyas d'acaciu",
  "block.minecraft.acacia_log": "Tueru d'acaciu",
  "block.minecraft.acacia_planks": "Tablonis d'acaciu",
  "block.minecraft.acacia_pressure_plate": "Placa' prisión d'acaciu",
  "block.minecraft.acacia_sapling": "Armuellu d'acaciu",
  "block.minecraft.acacia_shelf": "Balda d'acaciu",
  "block.minecraft.acacia_sign": "Endicaor d'acaciu",
  "block.minecraft.acacia_slab": "Llosa d'acaciu",
  "block.minecraft.acacia_stairs": "Escaleras d'acaciu",
  "block.minecraft.acacia_trapdoor": "Puirtuca d'acaciu",
  "block.minecraft.acacia_wall_hanging_sign": "Endicaor colganti d'acaciu en pader",
  "block.minecraft.acacia_wall_sign": "Endicaor d'acaciu en pader",
  "block.minecraft.acacia_wood": "Maera d'acaciu",
  "block.minecraft.activator_rail": "Raíl activaor",
  "block.minecraft.air": "Airi",
  "block.minecraft.allium": "Allium",
  "block.minecraft.amethyst_block": "Bloqui d'amatista",
  "block.minecraft.amethyst_cluster": "Ramu d'amatista",
  "block.minecraft.ancient_debris": "Escombriu vieju",
  "block.minecraft.andesite": "Andisita",
  "block.minecraft.andesite_slab": "Llosa d'andisita",
  "block.minecraft.andesite_stairs": "Escalonis d'andisita",
  "block.minecraft.andesite_wall": "Moriu d'andisita",
  "block.minecraft.anvil": "Unqui",
  "block.minecraft.attached_melon_stem": "Tayu sandía uníu",
  "block.minecraft.attached_pumpkin_stem": "Tayu calabaza uníu",
  "block.minecraft.azalea": "Azalea",
  "block.minecraft.azalea_leaves": "Jueyas d'azalea",
  "block.minecraft.azure_bluet": "Bluet",
  "block.minecraft.bamboo": "Bambú",
  "block.minecraft.bamboo_block": "Bloqui de bambú",
  "block.minecraft.bamboo_button": "Butón de bambú",
  "block.minecraft.bamboo_door": "Puerta de bambú",
  "block.minecraft.bamboo_fence": "Cierru de bambú",
  "block.minecraft.bamboo_fence_gate": "Purtillu de bambú",
  "block.minecraft.bamboo_hanging_sign": "Endicaor colganti de bambú",
  "block.minecraft.bamboo_mosaic": "Mosaicu de bambú",
  "block.minecraft.bamboo_mosaic_slab": "Llosa de mosaicu de bambú",
  "block.minecraft.bamboo_mosaic_stairs": "Escaleras de mosaicu de bambú",
  "block.minecraft.bamboo_planks": "Tablonis de bambú",
  "block.minecraft.bamboo_pressure_plate": "Placa' prisión de bambú",
  "block.minecraft.bamboo_sapling": "Esqueji de bambú",
  "block.minecraft.bamboo_shelf": "Balda de bambú",
  "block.minecraft.bamboo_sign": "Endicaor de bambú",
  "block.minecraft.bamboo_slab": "Llosa de bambú",
  "block.minecraft.bamboo_stairs": "Escaleras de bambú",
  "block.minecraft.bamboo_trapdoor": "Puirtuca de bambú",
  "block.minecraft.bamboo_wall_hanging_sign": "Endicaor colganti de bambú'n pader",
  "block.minecraft.bamboo_wall_sign": "Endicaor de bambú'n pader",
  "block.minecraft.banner.base.black": "Estandarti negru",
  "block.minecraft.banner.base.blue": "Estandarti azul",
  "block.minecraft.banner.base.brown": "Estandarti pardu",
  "block.minecraft.banner.base.cyan": "Estandarti cian",
  "block.minecraft.banner.base.gray": "Estandarti pedrés",
  "block.minecraft.banner.base.green": "Estandarti verdi",
  "block.minecraft.banner.base.light_blue": "Estandarti azul claru",
  "block.minecraft.banner.base.light_gray": "Estandarti pedrés claru",
  "block.minecraft.banner.base.lime": "Estandarti verdi lima",
  "block.minecraft.banner.base.magenta": "Estandarti magenta",
  "block.minecraft.banner.base.orange": "Estandarti naranja",
  "block.minecraft.banner.base.pink": "Estandarti rosa",
  "block.minecraft.banner.base.purple": "Estandarti moráu",
  "block.minecraft.banner.base.red": "Estandarti encarnáu",
  "block.minecraft.banner.base.white": "Estandarti brancu",
  "block.minecraft.banner.base.yellow": "Estandarti amarillu",
  "block.minecraft.banner.border.black": "Bordi negru",
  "block.minecraft.banner.border.blue": "Bordi azul",
  "block.minecraft.banner.border.brown": "Bordi pardu",
  "block.minecraft.banner.border.cyan": "Bordi cian",
  "block.minecraft.banner.border.gray": "Bordi pedrés",
  "block.minecraft.banner.border.green": "Bordi verdi",
  "block.minecraft.banner.border.light_blue": "Bordi azul claru",
  "block.minecraft.banner.border.light_gray": "Bordi pedrés claru",
  "block.minecraft.banner.border.lime": "Bordi verdi lima",
  "block.minecraft.banner.border.magenta": "Bordi magenta",
  "block.minecraft.banner.border.orange": "Bordi naranja",
  "block.minecraft.banner.border.pink": "Bordi rosa",
  "block.minecraft.banner.border.purple": "Bordi moráu",
  "block.minecraft.banner.border.red": "Bordi encarnáu",
  "block.minecraft.banner.border.white": "Bordi brancu",
  "block.minecraft.banner.border.yellow": "Bordi amarillu",
  "block.minecraft.banner.bricks.black": "Enladrilláu negru",
  "block.minecraft.banner.bricks.blue": "Enladrilláu azul",
  "block.minecraft.banner.bricks.brown": "Enladrilláu pardu",
  "block.minecraft.banner.bricks.cyan": "Enladrilláu cian",
  "block.minecraft.banner.bricks.gray": "Enladrilláu pedrés",
  "block.minecraft.banner.bricks.green": "Enladrilláu verdi",
  "block.minecraft.banner.bricks.light_blue": "Enladrilláu azul claru",
  "block.minecraft.banner.bricks.light_gray": "Enladrilláu pedrés claru",
  "block.minecraft.banner.bricks.lime": "Enladrilláu verdi lima",
  "block.minecraft.banner.bricks.magenta": "Enladrilláu magenta",
  "block.minecraft.banner.bricks.orange": "Enladrilláu naranja",
  "block.minecraft.banner.bricks.pink": "Enladrilláu rosa",
  "block.minecraft.banner.bricks.purple": "Enladrilláu moráu",
  "block.minecraft.banner.bricks.red": "Enladrilláu encarnáu",
  "block.minecraft.banner.bricks.white": "Enladrilláu brancu",
  "block.minecraft.banner.bricks.yellow": "Enladrilláu amarillu",
  "block.minecraft.banner.circle.black": "Puntu negru",
  "block.minecraft.banner.circle.blue": "Puntu azul",
  "block.minecraft.banner.circle.brown": "Puntu pardu",
  "block.minecraft.banner.circle.cyan": "Puntu cian",
  "block.minecraft.banner.circle.gray": "Puntu pedrés",
  "block.minecraft.banner.circle.green": "Puntu verdi",
  "block.minecraft.banner.circle.light_blue": "Puntu azul claru",
  "block.minecraft.banner.circle.light_gray": "Puntu pedrés claru",
  "block.minecraft.banner.circle.lime": "Puntu verdi lima",
  "block.minecraft.banner.circle.magenta": "Puntu magenta",
  "block.minecraft.banner.circle.orange": "Puntu naranja",
  "block.minecraft.banner.circle.pink": "Puntu rosa",
  "block.minecraft.banner.circle.purple": "Puntu moráu",
  "block.minecraft.banner.circle.red": "Puntu encarnáu",
  "block.minecraft.banner.circle.white": "Puntu brancu",
  "block.minecraft.banner.circle.yellow": "Puntu amarillu",
  "block.minecraft.banner.creeper.black": "Estampáu negru de creeper",
  "block.minecraft.banner.creeper.blue": "Estampáu de creeper azul",
  "block.minecraft.banner.creeper.brown": "Estampáu de creeper pardu",
  "block.minecraft.banner.creeper.cyan": "Estampáu de creeper cian",
  "block.minecraft.banner.creeper.gray": "Estampáu de creeper pedrés",
  "block.minecraft.banner.creeper.green": "Estampáu de creeper verdi",
  "block.minecraft.banner.creeper.light_blue": "Estampáu de creeper azul claru",
  "block.minecraft.banner.creeper.light_gray": "Estampáu de creeper pedrés claru",
  "block.minecraft.banner.creeper.lime": "Estampáu de creeper verdi lima",
  "block.minecraft.banner.creeper.magenta": "Estampáu de creeper magenta",
  "block.minecraft.banner.creeper.orange": "Estampáu de creeper naranja",
  "block.minecraft.banner.creeper.pink": "Estampáu de creeper brancu",
  "block.minecraft.banner.creeper.purple": "Estampáu de creeper moráu",
  "block.minecraft.banner.creeper.red": "Estampáu de creeper encarnáu",
  "block.minecraft.banner.creeper.white": "Estampáu de creeper brancu",
  "block.minecraft.banner.creeper.yellow": "Estampáu de creeper amarillu",
  "block.minecraft.banner.cross.black": "Aspas negras",
  "block.minecraft.banner.cross.blue": "Aspas azulis",
  "block.minecraft.banner.cross.brown": "Aspas pardas",
  "block.minecraft.banner.cross.cyan": "Aspas cian",
  "block.minecraft.banner.cross.gray": "Aspas pedrés",
  "block.minecraft.banner.cross.green": "Aspas verdis",
  "block.minecraft.banner.cross.light_blue": "Aspas azul claru",
  "block.minecraft.banner.cross.light_gray": "Aspas pedrés claru",
  "block.minecraft.banner.cross.lime": "Aspas verdi lima",
  "block.minecraft.banner.cross.magenta": "Aspas magenta",
  "block.minecraft.banner.cross.orange": "Aspas naranjas",
  "block.minecraft.banner.cross.pink": "Aspas rosas",
  "block.minecraft.banner.cross.purple": "Aspas moráa",
  "block.minecraft.banner.cross.red": "Aspas encarnáa",
  "block.minecraft.banner.cross.white": "Aspas branca",
  "block.minecraft.banner.cross.yellow": "Aspas amarilla",
  "block.minecraft.banner.curly_border.black": "Bordi negru dentáu",
  "block.minecraft.banner.curly_border.blue": "Bordi azul dentáu",
  "block.minecraft.banner.curly_border.brown": "Bordi pardu dentáu",
  "block.minecraft.banner.curly_border.cyan": "Bordi cian dentáu",
  "block.minecraft.banner.curly_border.gray": "Bordi pedrés dentáu",
  "block.minecraft.banner.curly_border.green": "Bordi verdi dentáu",
  "block.minecraft.banner.curly_border.light_blue": "Bordi azul claru dentáu",
  "block.minecraft.banner.curly_border.light_gray": "Bordi pedrés claru dentáu",
  "block.minecraft.banner.curly_border.lime": "Bordi verdi lima dentáu",
  "block.minecraft.banner.curly_border.magenta": "Bordi magenta dentáu",
  "block.minecraft.banner.curly_border.orange": "Bordi naranja dentáu",
  "block.minecraft.banner.curly_border.pink": "Bordi rosa dentáu",
  "block.minecraft.banner.curly_border.purple": "Bordi moráu dentáu",
  "block.minecraft.banner.curly_border.red": "Bordi encarnáu dentáu",
  "block.minecraft.banner.curly_border.white": "Bordi brancu dentáu",
  "block.minecraft.banner.curly_border.yellow": "Bordi amarillu dentáu",
  "block.minecraft.banner.diagonal_left.black": "Tajáu negru",
  "block.minecraft.banner.diagonal_left.blue": "Tajáu azul",
  "block.minecraft.banner.diagonal_left.brown": "Tajáu pardu",
  "block.minecraft.banner.diagonal_left.cyan": "Tajáu cian",
  "block.minecraft.banner.diagonal_left.gray": "Tajáu pedrés",
  "block.minecraft.banner.diagonal_left.green": "Tajáu verdi",
  "block.minecraft.banner.diagonal_left.light_blue": "Tajáu azul claru",
  "block.minecraft.banner.diagonal_left.light_gray": "Tajáu pedrés claru",
  "block.minecraft.banner.diagonal_left.lime": "Tajáu verdi lima",
  "block.minecraft.banner.diagonal_left.magenta": "Tajáu magenta",
  "block.minecraft.banner.diagonal_left.orange": "Tajáu naranja",
  "block.minecraft.banner.diagonal_left.pink": "Tajáu rosa",
  "block.minecraft.banner.diagonal_left.purple": "Tajáu moráu",
  "block.minecraft.banner.diagonal_left.red": "Tajáu encarnáu",
  "block.minecraft.banner.diagonal_left.white": "Tajáu brancu",
  "block.minecraft.banner.diagonal_left.yellow": "Tajáu amarillu",
  "block.minecraft.banner.diagonal_right.black": "Troncháu negru",
  "block.minecraft.banner.diagonal_right.blue": "Troncháu azul",
  "block.minecraft.banner.diagonal_right.brown": "Troncháu pardu",
  "block.minecraft.banner.diagonal_right.cyan": "Troncháu cian",
  "block.minecraft.banner.diagonal_right.gray": "Troncháu pedrés",
  "block.minecraft.banner.diagonal_right.green": "Troncháu verdi",
  "block.minecraft.banner.diagonal_right.light_blue": "Troncháu azul claru",
  "block.minecraft.banner.diagonal_right.light_gray": "Troncháu pedrés claru",
  "block.minecraft.banner.diagonal_right.lime": "Troncháu verdi lima",
  "block.minecraft.banner.diagonal_right.magenta": "Troncháu magenta",
  "block.minecraft.banner.diagonal_right.orange": "Troncháu naranja",
  "block.minecraft.banner.diagonal_right.pink": "Troncháu rosa",
  "block.minecraft.banner.diagonal_right.purple": "Troncháu moráu",
  "block.minecraft.banner.diagonal_right.red": "Troncháu encarnáu",
  "block.minecraft.banner.diagonal_right.white": "Troncháu brancu",
  "block.minecraft.banner.diagonal_right.yellow": "Troncháu amarillu",
  "block.minecraft.banner.diagonal_up_left.black": "Troncháu negru invirtíu",
  "block.minecraft.banner.diagonal_up_left.blue": "Troncháu azul invirtíu",
  "block.minecraft.banner.diagonal_up_left.brown": "Troncháu pardu invirtíu",
  "block.minecraft.banner.diagonal_up_left.cyan": "Troncháu cian invirtíu",
  "block.minecraft.banner.diagonal_up_left.gray": "Troncháu pedrés invirtíu",
  "block.minecraft.banner.diagonal_up_left.green": "Troncháu verdi invirtíu",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Troncháu azul claru invirtíu",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Troncháu pedrés claru invirtíu",
  "block.minecraft.banner.diagonal_up_left.lime": "Troncháu verdi lima invirtíu",
  "block.minecraft.banner.diagonal_up_left.magenta": "Troncháu magenta invirtíu",
  "block.minecraft.banner.diagonal_up_left.orange": "Troncháu naranja invirtíu",
  "block.minecraft.banner.diagonal_up_left.pink": "Troncháu rosa invirtíu",
  "block.minecraft.banner.diagonal_up_left.purple": "Troncháu moráu invirtíu",
  "block.minecraft.banner.diagonal_up_left.red": "Troncháu encarnáu invirtíu",
  "block.minecraft.banner.diagonal_up_left.white": "Troncháu brancu invirtíu",
  "block.minecraft.banner.diagonal_up_left.yellow": "Troncháu amarillu invitíu",
  "block.minecraft.banner.diagonal_up_right.black": "Tajáu negru invirtíu",
  "block.minecraft.banner.diagonal_up_right.blue": "Tajáu azul invirtíu",
  "block.minecraft.banner.diagonal_up_right.brown": "Tajáu pardu invirtíu",
  "block.minecraft.banner.diagonal_up_right.cyan": "Tajáu cian invirtíu",
  "block.minecraft.banner.diagonal_up_right.gray": "Tajáu pedrés invirtíu",
  "block.minecraft.banner.diagonal_up_right.green": "Tajáu verdi invirtíu",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Tajáu azul claru invirtíu",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Tajáu pedrés claru invirtíu",
  "block.minecraft.banner.diagonal_up_right.lime": "Tajáu verdi lima invirtíu",
  "block.minecraft.banner.diagonal_up_right.magenta": "Tajáu magenta invirtíu",
  "block.minecraft.banner.diagonal_up_right.orange": "Tajáu naranja invirtíu",
  "block.minecraft.banner.diagonal_up_right.pink": "Tajáu rosa invirtíu",
  "block.minecraft.banner.diagonal_up_right.purple": "Tajáu moráu invirtíu",
  "block.minecraft.banner.diagonal_up_right.red": "Tajáu encarnáu invirtíu",
  "block.minecraft.banner.diagonal_up_right.white": "Tajáu brancu invirtíu",
  "block.minecraft.banner.diagonal_up_right.yellow": "Tajáu amarillu invirtíu",
  "block.minecraft.banner.flow.black": "Estampáu d'espiral negru",
  "block.minecraft.banner.flow.blue": "Estampáu d'espiral azul",
  "block.minecraft.banner.flow.brown": "Estampáu d'espiral pardu",
  "block.minecraft.banner.flow.cyan": "Estampáu d'espiral cian",
  "block.minecraft.banner.flow.gray": "Estampáu d'espiral pedrés",
  "block.minecraft.banner.flow.green": "Estampáu d'espiral verdi",
  "block.minecraft.banner.flow.light_blue": "Estampáu d'espiral azul claru",
  "block.minecraft.banner.flow.light_gray": "Estampáu d'espiral pedrés claru",
  "block.minecraft.banner.flow.lime": "Estampáu d'espiral verdi lima",
  "block.minecraft.banner.flow.magenta": "Estampáu d'espiral magenta",
  "block.minecraft.banner.flow.orange": "Estampáu d'espiral naranja",
  "block.minecraft.banner.flow.pink": "Estampáu d'espiral rosa",
  "block.minecraft.banner.flow.purple": "Estampáu d'espiral moráu",
  "block.minecraft.banner.flow.red": "Estampáu d'espiral encarnáu",
  "block.minecraft.banner.flow.white": "Estampáu d'espiral brancu",
  "block.minecraft.banner.flow.yellow": "Estampáu d'espiral amarillu",
  "block.minecraft.banner.flower.black": "Estampáu de jlor negru",
  "block.minecraft.banner.flower.blue": "Estampáu de jlor azul",
  "block.minecraft.banner.flower.brown": "Estampáu de jlor pardu",
  "block.minecraft.banner.flower.cyan": "Estampáu de jlor cian",
  "block.minecraft.banner.flower.gray": "Estampáu de jlor pedrés",
  "block.minecraft.banner.flower.green": "Estampáu de jlor verdi",
  "block.minecraft.banner.flower.light_blue": "Estampáu de jlor azul claru",
  "block.minecraft.banner.flower.light_gray": "Estampáu de jlor pedrés claru",
  "block.minecraft.banner.flower.lime": "Estampáu de jlor verdi lima",
  "block.minecraft.banner.flower.magenta": "Estampáu de jlor magenta",
  "block.minecraft.banner.flower.orange": "Estampáu de jlor naranja",
  "block.minecraft.banner.flower.pink": "Estampáu de jlor rosa",
  "block.minecraft.banner.flower.purple": "Estampáu de jlor moráu",
  "block.minecraft.banner.flower.red": "Estampáu de jlor encarnáu",
  "block.minecraft.banner.flower.white": "Estampáu de jlor brancu",
  "block.minecraft.banner.flower.yellow": "Estampáu de jlor amarillu",
  "block.minecraft.banner.globe.black": "Planeta negru",
  "block.minecraft.banner.globe.blue": "Planeta azul",
  "block.minecraft.banner.globe.brown": "Planeta pardu",
  "block.minecraft.banner.globe.cyan": "Planeta cian",
  "block.minecraft.banner.globe.gray": "Planeta pedrés",
  "block.minecraft.banner.globe.green": "Planeta verdi",
  "block.minecraft.banner.globe.light_blue": "Planeta azul claru",
  "block.minecraft.banner.globe.light_gray": "Planeta pedrés claru",
  "block.minecraft.banner.globe.lime": "Planeta verdi lima",
  "block.minecraft.banner.globe.magenta": "Planeta magenta",
  "block.minecraft.banner.globe.orange": "Planeta naranja",
  "block.minecraft.banner.globe.pink": "Planeta rosa",
  "block.minecraft.banner.globe.purple": "Planeta moráu",
  "block.minecraft.banner.globe.red": "Planeta encarnáu",
  "block.minecraft.banner.globe.white": "Planeta brancu",
  "block.minecraft.banner.globe.yellow": "Planeta amarillu",
  "block.minecraft.banner.gradient.black": "Degradáu negru",
  "block.minecraft.banner.gradient.blue": "Degradáu azul",
  "block.minecraft.banner.gradient.brown": "Degradáu pardu",
  "block.minecraft.banner.gradient.cyan": "Degradáu cian",
  "block.minecraft.banner.gradient.gray": "Degradáu pedrés",
  "block.minecraft.banner.gradient.green": "Degradáu verdi",
  "block.minecraft.banner.gradient.light_blue": "Degradáu azul claru",
  "block.minecraft.banner.gradient.light_gray": "Degradáu pedrés claru",
  "block.minecraft.banner.gradient.lime": "Degradáu verdi lima",
  "block.minecraft.banner.gradient.magenta": "Degradáu magenta",
  "block.minecraft.banner.gradient.orange": "Degradáu naranja",
  "block.minecraft.banner.gradient.pink": "Degradáu rosa",
  "block.minecraft.banner.gradient.purple": "Degradáu moráu",
  "block.minecraft.banner.gradient.red": "Degradáu encarnáu",
  "block.minecraft.banner.gradient.white": "Degradáu brancu",
  "block.minecraft.banner.gradient.yellow": "Degradáu amarillu",
  "block.minecraft.banner.gradient_up.black": "Degradáu negru'n basi",
  "block.minecraft.banner.gradient_up.blue": "Degradáu azul en basi",
  "block.minecraft.banner.gradient_up.brown": "Degradáu pardu'n basi",
  "block.minecraft.banner.gradient_up.cyan": "Degradáu cian en basi",
  "block.minecraft.banner.gradient_up.gray": "Degradáu pedrés en basi",
  "block.minecraft.banner.gradient_up.green": "Degradáu verdi'n basi",
  "block.minecraft.banner.gradient_up.light_blue": "Degradáu azul claru'n basi",
  "block.minecraft.banner.gradient_up.light_gray": "Degradáu pedrés claru'n basi",
  "block.minecraft.banner.gradient_up.lime": "Degradáu verdi lima'n basi",
  "block.minecraft.banner.gradient_up.magenta": "Degradáu magenta'n basi",
  "block.minecraft.banner.gradient_up.orange": "Degradáu naranja'n basi",
  "block.minecraft.banner.gradient_up.pink": "Degradáu rosa'n basi",
  "block.minecraft.banner.gradient_up.purple": "Degradáu moráu'n basi",
  "block.minecraft.banner.gradient_up.red": "Degradáu encarnáu'n basi",
  "block.minecraft.banner.gradient_up.white": "Degradáu brancu'n basi",
  "block.minecraft.banner.gradient_up.yellow": "Degradáu amarillu'n basi",
  "block.minecraft.banner.guster.black": "Estampáu negru de breeze",
  "block.minecraft.banner.guster.blue": "Estampáu azul de breeze",
  "block.minecraft.banner.guster.brown": "Estampáu pardu de breeze",
  "block.minecraft.banner.guster.cyan": "Estampáu cian de breeze",
  "block.minecraft.banner.guster.gray": "Estampáu pedrés de breeze",
  "block.minecraft.banner.guster.green": "Estampáu verdi de breeze",
  "block.minecraft.banner.guster.light_blue": "Estampáu azul claru de breeze",
  "block.minecraft.banner.guster.light_gray": "Estampáu pedrés claru de breeze",
  "block.minecraft.banner.guster.lime": "Estampáu verdi lima de breeze",
  "block.minecraft.banner.guster.magenta": "Estampáu magenta de breeze",
  "block.minecraft.banner.guster.orange": "Estampáu naranja de breeze",
  "block.minecraft.banner.guster.pink": "Estampáu rosa de breeze",
  "block.minecraft.banner.guster.purple": "Estampáu moráu de breeze",
  "block.minecraft.banner.guster.red": "Estampáu encarnáu de breeze",
  "block.minecraft.banner.guster.white": "Estampáu brancu de breeze",
  "block.minecraft.banner.guster.yellow": "Estampáu amarillu de breeze",
  "block.minecraft.banner.half_horizontal.black": "Cortáu negru",
  "block.minecraft.banner.half_horizontal.blue": "Cortáu azul",
  "block.minecraft.banner.half_horizontal.brown": "Cortáu pardu",
  "block.minecraft.banner.half_horizontal.cyan": "Cortáu cian",
  "block.minecraft.banner.half_horizontal.gray": "Cortáu pedrés",
  "block.minecraft.banner.half_horizontal.green": "Cortáu verdi",
  "block.minecraft.banner.half_horizontal.light_blue": "Cortáu azul claru",
  "block.minecraft.banner.half_horizontal.light_gray": "Cortáu pedrés claru",
  "block.minecraft.banner.half_horizontal.lime": "Cortáu verdi lima",
  "block.minecraft.banner.half_horizontal.magenta": "Cortáu magenta",
  "block.minecraft.banner.half_horizontal.orange": "Cortáu naranja",
  "block.minecraft.banner.half_horizontal.pink": "Cortáu rosa",
  "block.minecraft.banner.half_horizontal.purple": "Cortáu moráu",
  "block.minecraft.banner.half_horizontal.red": "Cortáu encarnáu",
  "block.minecraft.banner.half_horizontal.white": "Cortáu brancu",
  "block.minecraft.banner.half_horizontal.yellow": "Cortáu amarillu",
  "block.minecraft.banner.half_horizontal_bottom.black": "Cortáu negru invirtíu",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Cortáu azul invirtíu",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Cortáu pardu invirtíu",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Cortáu cian invirtíu",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Cortáu pedrés invirtíu",
  "block.minecraft.banner.half_horizontal_bottom.green": "Cortáu verdi invirtíu",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Cortáu azul claru invirtíu",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Cortáu pedrés claru invirtíu",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Cortáu verdi lima invirtíu",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Cortáu magenta invirtíu",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Cortáu naranja invirtíu",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Cortáu rosa invirtíu",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Cortáu moráu invirtíu",
  "block.minecraft.banner.half_horizontal_bottom.red": "Cortáu encarnáu invirtíu",
  "block.minecraft.banner.half_horizontal_bottom.white": "Cortáu brancu invirtíu",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Cortáu amarillu invirtíu",
  "block.minecraft.banner.half_vertical.black": "Mitá diestra'n negru",
  "block.minecraft.banner.half_vertical.blue": "Mitá diestra n'azul",
  "block.minecraft.banner.half_vertical.brown": "Mitá diestra parda",
  "block.minecraft.banner.half_vertical.cyan": "Mitá diestra'n cian",
  "block.minecraft.banner.half_vertical.gray": "Mitá diestra pedrés",
  "block.minecraft.banner.half_vertical.green": "Mitá diestra'n verdi",
  "block.minecraft.banner.half_vertical.light_blue": "Mitá diestra n'azul claru",
  "block.minecraft.banner.half_vertical.light_gray": "Mitá diestra pedrés claru",
  "block.minecraft.banner.half_vertical.lime": "Mitá diestra'n verdi lima",
  "block.minecraft.banner.half_vertical.magenta": "Mitá diestra'n magenta",
  "block.minecraft.banner.half_vertical.orange": "Mitá diestra'n naranja",
  "block.minecraft.banner.half_vertical.pink": "Mitá diestra'n rosa",
  "block.minecraft.banner.half_vertical.purple": "Mitá diestra'n moráu",
  "block.minecraft.banner.half_vertical.red": "Mitá diestra encarnáa",
  "block.minecraft.banner.half_vertical.white": "Mitá diestra'n brancu",
  "block.minecraft.banner.half_vertical.yellow": "Mitá diestra'n amarillu",
  "block.minecraft.banner.half_vertical_right.black": "Mitá zurda'n negru",
  "block.minecraft.banner.half_vertical_right.blue": "Mitá zurda n'azul",
  "block.minecraft.banner.half_vertical_right.brown": "Mitá zurda pardu",
  "block.minecraft.banner.half_vertical_right.cyan": "Mitá zurda'n cian",
  "block.minecraft.banner.half_vertical_right.gray": "Mitá zurda pedrés",
  "block.minecraft.banner.half_vertical_right.green": "Mitá zurda'n verdi",
  "block.minecraft.banner.half_vertical_right.light_blue": "Mitá zurda n'azul",
  "block.minecraft.banner.half_vertical_right.light_gray": "Mitá zurda en pedrés",
  "block.minecraft.banner.half_vertical_right.lime": "Mitá zurda'n verdi lima",
  "block.minecraft.banner.half_vertical_right.magenta": "Mitá zurda'n magenta",
  "block.minecraft.banner.half_vertical_right.orange": "Mitá zurda'n naranja",
  "block.minecraft.banner.half_vertical_right.pink": "Mitá zurda'n rosa",
  "block.minecraft.banner.half_vertical_right.purple": "Mitá zurda'n moráu",
  "block.minecraft.banner.half_vertical_right.red": "Mitá zurda encarnáa",
  "block.minecraft.banner.half_vertical_right.white": "Mitá zurda'n brancu",
  "block.minecraft.banner.half_vertical_right.yellow": "Mitá zurda'n amarillu",
  "block.minecraft.banner.mojang.black": "Estampáu negru d'un cosu",
  "block.minecraft.banner.mojang.blue": "Estampáu azul d'un cosu",
  "block.minecraft.banner.mojang.brown": "Estampáu pardu d'un cosu",
  "block.minecraft.banner.mojang.cyan": "Estampáu cian d'un cosu",
  "block.minecraft.banner.mojang.gray": "Estampáu pedrés d'un cosu",
  "block.minecraft.banner.mojang.green": "Estampáu verdi d'un cosu",
  "block.minecraft.banner.mojang.light_blue": "Estampáu azul claru d'un cosu",
  "block.minecraft.banner.mojang.light_gray": "Estampáu pedrés d'un cosu",
  "block.minecraft.banner.mojang.lime": "Estampáu verdi lima d'un cosu",
  "block.minecraft.banner.mojang.magenta": "Estampáu magenta d'un cosu",
  "block.minecraft.banner.mojang.orange": "Estampáu naranja d'un cosu",
  "block.minecraft.banner.mojang.pink": "Estampáu rosa d'un cosu",
  "block.minecraft.banner.mojang.purple": "Estampáu moráu d'un cosu",
  "block.minecraft.banner.mojang.red": "Estampáu encarnáu d'un cosu",
  "block.minecraft.banner.mojang.white": "Estampáu brancu d'un cosu",
  "block.minecraft.banner.mojang.yellow": "Estampáu amarillu d'un cosu",
  "block.minecraft.banner.piglin.black": "Jucicu negru",
  "block.minecraft.banner.piglin.blue": "Jucicu azul",
  "block.minecraft.banner.piglin.brown": "Jucicu pardu",
  "block.minecraft.banner.piglin.cyan": "Jucicu cian",
  "block.minecraft.banner.piglin.gray": "Jucicu pedrés",
  "block.minecraft.banner.piglin.green": "Jucicu verdi",
  "block.minecraft.banner.piglin.light_blue": "Jucicu azul claru",
  "block.minecraft.banner.piglin.light_gray": "Jucicu pedrés claru",
  "block.minecraft.banner.piglin.lime": "Jucicu verdi lima",
  "block.minecraft.banner.piglin.magenta": "Jucicu magenta",
  "block.minecraft.banner.piglin.orange": "Jucicu naranja",
  "block.minecraft.banner.piglin.pink": "Jucicu rosa",
  "block.minecraft.banner.piglin.purple": "Jucicu moráu",
  "block.minecraft.banner.piglin.red": "Jucicu encarnáu",
  "block.minecraft.banner.piglin.white": "Jucicu brancu",
  "block.minecraft.banner.piglin.yellow": "Jucicu amarillu",
  "block.minecraft.banner.rhombus.black": "Rombu negru",
  "block.minecraft.banner.rhombus.blue": "Rombu azul",
  "block.minecraft.banner.rhombus.brown": "Rombu pardu",
  "block.minecraft.banner.rhombus.cyan": "Rombu cian",
  "block.minecraft.banner.rhombus.gray": "Rombu pedrés",
  "block.minecraft.banner.rhombus.green": "Rombu verdi",
  "block.minecraft.banner.rhombus.light_blue": "Rombu azul claru",
  "block.minecraft.banner.rhombus.light_gray": "Rombu pedrés claru",
  "block.minecraft.banner.rhombus.lime": "Rombu verdi lima",
  "block.minecraft.banner.rhombus.magenta": "Rombu magenta",
  "block.minecraft.banner.rhombus.orange": "Rombu naranja",
  "block.minecraft.banner.rhombus.pink": "Rombu rosa",
  "block.minecraft.banner.rhombus.purple": "Rombu moráu",
  "block.minecraft.banner.rhombus.red": "Rombu encarnáu",
  "block.minecraft.banner.rhombus.white": "Rombu brancu",
  "block.minecraft.banner.rhombus.yellow": "Rombu amarillu",
  "block.minecraft.banner.skull.black": "Estampáu de calavera negru",
  "block.minecraft.banner.skull.blue": "Estampáu de clavera azul",
  "block.minecraft.banner.skull.brown": "Estampáu de clavera pardu",
  "block.minecraft.banner.skull.cyan": "Estampáu de clavera cian",
  "block.minecraft.banner.skull.gray": "Estampáu de clavera pedrés",
  "block.minecraft.banner.skull.green": "Estampáu de clavera verdi",
  "block.minecraft.banner.skull.light_blue": "Estampáu de clavera azul claru",
  "block.minecraft.banner.skull.light_gray": "Estampáu de clavera pedrés claru",
  "block.minecraft.banner.skull.lime": "Estampáu de clavera verdi lima",
  "block.minecraft.banner.skull.magenta": "Estampáu de clavera magenta",
  "block.minecraft.banner.skull.orange": "Estampáu de clavera naranja",
  "block.minecraft.banner.skull.pink": "Estampáu de clavera rosa",
  "block.minecraft.banner.skull.purple": "Estampáu de clavera moráu",
  "block.minecraft.banner.skull.red": "Estampáu de clavera encarnáu",
  "block.minecraft.banner.skull.white": "Estampáu de clavera brancu",
  "block.minecraft.banner.skull.yellow": "Estampáu de clavera amarillu",
  "block.minecraft.banner.small_stripes.black": "Rayáu negru",
  "block.minecraft.banner.small_stripes.blue": "Rayáu azul",
  "block.minecraft.banner.small_stripes.brown": "Rayáu pardu",
  "block.minecraft.banner.small_stripes.cyan": "Rayáu cian",
  "block.minecraft.banner.small_stripes.gray": "Rayáu pedrés",
  "block.minecraft.banner.small_stripes.green": "Rayáu verdi",
  "block.minecraft.banner.small_stripes.light_blue": "Rayáu azul claru",
  "block.minecraft.banner.small_stripes.light_gray": "Rayáu pedrés claru",
  "block.minecraft.banner.small_stripes.lime": "Rayáu verdi lima",
  "block.minecraft.banner.small_stripes.magenta": "Rayáu magenta",
  "block.minecraft.banner.small_stripes.orange": "Rayáu naranja",
  "block.minecraft.banner.small_stripes.pink": "Rayáu rosa",
  "block.minecraft.banner.small_stripes.purple": "Rayáu moráu",
  "block.minecraft.banner.small_stripes.red": "Rayáu encarnáu",
  "block.minecraft.banner.small_stripes.white": "Rayáu brancu",
  "block.minecraft.banner.small_stripes.yellow": "Rayáu amarillu",
  "block.minecraft.banner.square_bottom_left.black": "Cantu diestru superior negru",
  "block.minecraft.banner.square_bottom_left.blue": "Cantu diestru superior azul",
  "block.minecraft.banner.square_bottom_left.brown": "Cantu diestru pardu'n basi",
  "block.minecraft.banner.square_bottom_left.cyan": "Cantu diestru cian en basi",
  "block.minecraft.banner.square_bottom_left.gray": "Cantu diestru pedrés en basi",
  "block.minecraft.banner.square_bottom_left.green": "Cantu diestru verdi'n basi",
  "block.minecraft.banner.square_bottom_left.light_blue": "Cantu diestru azul en basi",
  "block.minecraft.banner.square_bottom_left.light_gray": "Cantu diestru pedrés claru'n basi",
  "block.minecraft.banner.square_bottom_left.lime": "Cantu diestru verdi lima'n basi",
  "block.minecraft.banner.square_bottom_left.magenta": "Cantu diestru magenta'n basi",
  "block.minecraft.banner.square_bottom_left.orange": "Cantu diestru naranja'n basi",
  "block.minecraft.banner.square_bottom_left.pink": "Cantu diestru rosa'n basi",
  "block.minecraft.banner.square_bottom_left.purple": "Cantu diestru moráu'n basi",
  "block.minecraft.banner.square_bottom_left.red": "Cantu diestru encarnáu'n basi",
  "block.minecraft.banner.square_bottom_left.white": "Cantu diestru brancu'n basi",
  "block.minecraft.banner.square_bottom_left.yellow": "Cantu diestru amarillu'n basi",
  "block.minecraft.banner.square_bottom_right.black": "Cantu zurdu negru'n basi",
  "block.minecraft.banner.square_bottom_right.blue": "Cantu zurdu azul en basi",
  "block.minecraft.banner.square_bottom_right.brown": "Cantu zurdu pardu'n basi",
  "block.minecraft.banner.square_bottom_right.cyan": "Cantu zurdu cian en basi",
  "block.minecraft.banner.square_bottom_right.gray": "Cantu zurdu pedrés en basi",
  "block.minecraft.banner.square_bottom_right.green": "Cantu zurdu verdi'n basi",
  "block.minecraft.banner.square_bottom_right.light_blue": "Cantu zurdu azul claru'n basi",
  "block.minecraft.banner.square_bottom_right.light_gray": "Cantu zurdu pedrés claru'n basi",
  "block.minecraft.banner.square_bottom_right.lime": "Cantu zurdu verdi lima'n basi",
  "block.minecraft.banner.square_bottom_right.magenta": "Cantu zurdu magenta'n basi",
  "block.minecraft.banner.square_bottom_right.orange": "Cantu zurdu naranja'n basi",
  "block.minecraft.banner.square_bottom_right.pink": "Cantu zurdu rosa'n basi",
  "block.minecraft.banner.square_bottom_right.purple": "Cantu zurdu moráu'n basi",
  "block.minecraft.banner.square_bottom_right.red": "Cantu zurdu encarnáu'n basi",
  "block.minecraft.banner.square_bottom_right.white": "Cantu zurdu brancu'n basi",
  "block.minecraft.banner.square_bottom_right.yellow": "Cantu zurdu amarillu'n basi",
  "block.minecraft.banner.square_top_left.black": "Cantu diestru negru altu",
  "block.minecraft.banner.square_top_left.blue": "Cantu diestru azul altu",
  "block.minecraft.banner.square_top_left.brown": "Cantu diestru pardu altu",
  "block.minecraft.banner.square_top_left.cyan": "Cantu diestru cian altu",
  "block.minecraft.banner.square_top_left.gray": "Cantu diestru pedrés altu",
  "block.minecraft.banner.square_top_left.green": "Cantu diestru verdi altu",
  "block.minecraft.banner.square_top_left.light_blue": "Cantu diestru azul claru altu",
  "block.minecraft.banner.square_top_left.light_gray": "Cantu diestru pedrés claru altu",
  "block.minecraft.banner.square_top_left.lime": "Cantu diestru verdi lima altu",
  "block.minecraft.banner.square_top_left.magenta": "Cantu diestru pardu altu",
  "block.minecraft.banner.square_top_left.orange": "Cantu diestru naranja altu",
  "block.minecraft.banner.square_top_left.pink": "Cantu diestru rosa altu",
  "block.minecraft.banner.square_top_left.purple": "Cantu diestru moráu altu",
  "block.minecraft.banner.square_top_left.red": "Cantu diestru encarnáu altu",
  "block.minecraft.banner.square_top_left.white": "Cantu diestru brancu altu",
  "block.minecraft.banner.square_top_left.yellow": "Cantu diestru amarillu altu",
  "block.minecraft.banner.square_top_right.black": "Cantu diestru negru altu",
  "block.minecraft.banner.square_top_right.blue": "Cantu zurdu azul altu",
  "block.minecraft.banner.square_top_right.brown": "Cantu zurdu pardu altu",
  "block.minecraft.banner.square_top_right.cyan": "Cantu zurdu cian altu",
  "block.minecraft.banner.square_top_right.gray": "Cantu zurdu pedrés altu",
  "block.minecraft.banner.square_top_right.green": "Cantu zurdu verdi altu",
  "block.minecraft.banner.square_top_right.light_blue": "Cantu zurdu azul claru altu",
  "block.minecraft.banner.square_top_right.light_gray": "Cantu zurdu pedrés claru altu",
  "block.minecraft.banner.square_top_right.lime": "Cantu zurdu verdi lima altu",
  "block.minecraft.banner.square_top_right.magenta": "Cantu zurdu magenta altu",
  "block.minecraft.banner.square_top_right.orange": "Cantu zurdu naranja altu",
  "block.minecraft.banner.square_top_right.pink": "Cantu zurdu rosa altu",
  "block.minecraft.banner.square_top_right.purple": "Cantu zurdu moráu altu",
  "block.minecraft.banner.square_top_right.red": "Cantu zurdu encarnáu altu",
  "block.minecraft.banner.square_top_right.white": "Cantu zurdu brancu altu",
  "block.minecraft.banner.square_top_right.yellow": "Cantu zurdu amarillu altu",
  "block.minecraft.banner.straight_cross.black": "Cruz negra",
  "block.minecraft.banner.straight_cross.blue": "Cruz azul",
  "block.minecraft.banner.straight_cross.brown": "Cruz parda",
  "block.minecraft.banner.straight_cross.cyan": "Cruz cian",
  "block.minecraft.banner.straight_cross.gray": "Cruz pedrés",
  "block.minecraft.banner.straight_cross.green": "Cruz verdi",
  "block.minecraft.banner.straight_cross.light_blue": "Cruz azul claru",
  "block.minecraft.banner.straight_cross.light_gray": "Cruz pedrés claru",
  "block.minecraft.banner.straight_cross.lime": "Cruz verdi lima",
  "block.minecraft.banner.straight_cross.magenta": "Cruz magenta",
  "block.minecraft.banner.straight_cross.orange": "Cruz naranja",
  "block.minecraft.banner.straight_cross.pink": "Cruz rosa",
  "block.minecraft.banner.straight_cross.purple": "Cruz moráa",
  "block.minecraft.banner.straight_cross.red": "Cruz encarnáa",
  "block.minecraft.banner.straight_cross.white": "Cruz branca",
  "block.minecraft.banner.straight_cross.yellow": "Cruz amarilla",
  "block.minecraft.banner.stripe_bottom.black": "Terciu baju negru",
  "block.minecraft.banner.stripe_bottom.blue": "Terciu baju azul",
  "block.minecraft.banner.stripe_bottom.brown": "Terciu baju pardu",
  "block.minecraft.banner.stripe_bottom.cyan": "Terciu baju cian",
  "block.minecraft.banner.stripe_bottom.gray": "Terciu baju pedrés",
  "block.minecraft.banner.stripe_bottom.green": "Terciu baju verdi",
  "block.minecraft.banner.stripe_bottom.light_blue": "Terciu baju azul claru",
  "block.minecraft.banner.stripe_bottom.light_gray": "Terciu baju pedrés claru",
  "block.minecraft.banner.stripe_bottom.lime": "Terciu baju verdi lima",
  "block.minecraft.banner.stripe_bottom.magenta": "Terciu baju magenta",
  "block.minecraft.banner.stripe_bottom.orange": "Terciu baju naranja",
  "block.minecraft.banner.stripe_bottom.pink": "Terciu baju rosa",
  "block.minecraft.banner.stripe_bottom.purple": "Terciu baju moráu",
  "block.minecraft.banner.stripe_bottom.red": "Terciu baju encarnáu",
  "block.minecraft.banner.stripe_bottom.white": "Terciu baju brancu",
  "block.minecraft.banner.stripe_bottom.yellow": "Terciu baju amarillu",
  "block.minecraft.banner.stripe_center.black": "Palu negru",
  "block.minecraft.banner.stripe_center.blue": "Palu azul",
  "block.minecraft.banner.stripe_center.brown": "Palu pardu",
  "block.minecraft.banner.stripe_center.cyan": "Palu cian",
  "block.minecraft.banner.stripe_center.gray": "Palu pedrés",
  "block.minecraft.banner.stripe_center.green": "Palu verdi",
  "block.minecraft.banner.stripe_center.light_blue": "Palu azul claru",
  "block.minecraft.banner.stripe_center.light_gray": "Palu gris claru",
  "block.minecraft.banner.stripe_center.lime": "Palu verdi lima",
  "block.minecraft.banner.stripe_center.magenta": "Palu magenta",
  "block.minecraft.banner.stripe_center.orange": "Palu naranja",
  "block.minecraft.banner.stripe_center.pink": "Palu rosa",
  "block.minecraft.banner.stripe_center.purple": "Palu moráu",
  "block.minecraft.banner.stripe_center.red": "Palu encarnáu",
  "block.minecraft.banner.stripe_center.white": "Palu brancu",
  "block.minecraft.banner.stripe_center.yellow": "Palu amarillu",
  "block.minecraft.banner.stripe_downleft.black": "Banda pa riba negra",
  "block.minecraft.banner.stripe_downleft.blue": "Banda pa riba azul",
  "block.minecraft.banner.stripe_downleft.brown": "Banda pa riba parda",
  "block.minecraft.banner.stripe_downleft.cyan": "Banda pa riba cian",
  "block.minecraft.banner.stripe_downleft.gray": "Banda pa riba pedrés",
  "block.minecraft.banner.stripe_downleft.green": "Banda pa riba verdi",
  "block.minecraft.banner.stripe_downleft.light_blue": "Banda pa riba azul claru",
  "block.minecraft.banner.stripe_downleft.light_gray": "Banda pa riba pedrés claru",
  "block.minecraft.banner.stripe_downleft.lime": "Banda pa riba verdi lima",
  "block.minecraft.banner.stripe_downleft.magenta": "Banda pa riba magenta",
  "block.minecraft.banner.stripe_downleft.orange": "Banda pa riba naranja",
  "block.minecraft.banner.stripe_downleft.pink": "Banda pa riba rosa",
  "block.minecraft.banner.stripe_downleft.purple": "Banda pa riba moráa",
  "block.minecraft.banner.stripe_downleft.red": "Banda pa riba encarnáa",
  "block.minecraft.banner.stripe_downleft.white": "Banda pa riba branca",
  "block.minecraft.banner.stripe_downleft.yellow": "Banda pa riba amarilla",
  "block.minecraft.banner.stripe_downright.black": "Banda p'abaju negra",
  "block.minecraft.banner.stripe_downright.blue": "Banda p'abaju azul",
  "block.minecraft.banner.stripe_downright.brown": "Banda p'abaju parda",
  "block.minecraft.banner.stripe_downright.cyan": "Banda p'abaju cian",
  "block.minecraft.banner.stripe_downright.gray": "Banda p'abaju pedrés",
  "block.minecraft.banner.stripe_downright.green": "Banda p'abaju verdi",
  "block.minecraft.banner.stripe_downright.light_blue": "Banda p'abaju azul claru",
  "block.minecraft.banner.stripe_downright.light_gray": "Banda p'abaju pedrés claru",
  "block.minecraft.banner.stripe_downright.lime": "Banda p'abaju verdi lima",
  "block.minecraft.banner.stripe_downright.magenta": "Banda p'abaju magenta",
  "block.minecraft.banner.stripe_downright.orange": "Banda p'abaju naranja",
  "block.minecraft.banner.stripe_downright.pink": "Banda p'abaju rosa",
  "block.minecraft.banner.stripe_downright.purple": "Banda p'abaju moráa",
  "block.minecraft.banner.stripe_downright.red": "Banda p'abaju encarnáa",
  "block.minecraft.banner.stripe_downright.white": "Banda p'abaju branca",
  "block.minecraft.banner.stripe_downright.yellow": "Banda p'abaju amarilla",
  "block.minecraft.banner.stripe_left.black": "Palu diestru negru",
  "block.minecraft.banner.stripe_left.blue": "Palu diestru azul",
  "block.minecraft.banner.stripe_left.brown": "Palu diestru pardu",
  "block.minecraft.banner.stripe_left.cyan": "Palu diestru cian",
  "block.minecraft.banner.stripe_left.gray": "Palu diestru pedrés",
  "block.minecraft.banner.stripe_left.green": "Palu diestru verdi",
  "block.minecraft.banner.stripe_left.light_blue": "Palu diestru azul claru",
  "block.minecraft.banner.stripe_left.light_gray": "Palu diestru pedrés claru",
  "block.minecraft.banner.stripe_left.lime": "Palu diestru verdi lima",
  "block.minecraft.banner.stripe_left.magenta": "Palu diestru magenta",
  "block.minecraft.banner.stripe_left.orange": "Palu diestru naranja",
  "block.minecraft.banner.stripe_left.pink": "Palu diestru rosa",
  "block.minecraft.banner.stripe_left.purple": "Palu diestru moráu",
  "block.minecraft.banner.stripe_left.red": "Palu diestru encarnáu",
  "block.minecraft.banner.stripe_left.white": "Palu diestru brancu",
  "block.minecraft.banner.stripe_left.yellow": "Palu diestru amarillu",
  "block.minecraft.banner.stripe_middle.black": "Jranja negra",
  "block.minecraft.banner.stripe_middle.blue": "Jranja azul",
  "block.minecraft.banner.stripe_middle.brown": "Jranja parda",
  "block.minecraft.banner.stripe_middle.cyan": "Jranja cian",
  "block.minecraft.banner.stripe_middle.gray": "Jranja pedrés",
  "block.minecraft.banner.stripe_middle.green": "Jranja verdi",
  "block.minecraft.banner.stripe_middle.light_blue": "Jranja azul claru",
  "block.minecraft.banner.stripe_middle.light_gray": "Jranja pedrés claru",
  "block.minecraft.banner.stripe_middle.lime": "Jranja verdi lima",
  "block.minecraft.banner.stripe_middle.magenta": "Jranja magenta",
  "block.minecraft.banner.stripe_middle.orange": "Jranja naranja",
  "block.minecraft.banner.stripe_middle.pink": "Jranja rosa",
  "block.minecraft.banner.stripe_middle.purple": "Jranja moráa",
  "block.minecraft.banner.stripe_middle.red": "Jranja encarnáa",
  "block.minecraft.banner.stripe_middle.white": "Jranja branca",
  "block.minecraft.banner.stripe_middle.yellow": "Jranja amarilla",
  "block.minecraft.banner.stripe_right.black": "Palu zurdu negru",
  "block.minecraft.banner.stripe_right.blue": "Palu zurdu azul",
  "block.minecraft.banner.stripe_right.brown": "Palu zurdu pardu",
  "block.minecraft.banner.stripe_right.cyan": "Palu zurdu cian",
  "block.minecraft.banner.stripe_right.gray": "Palu zurdu pedrés",
  "block.minecraft.banner.stripe_right.green": "Palu zurdu verdi",
  "block.minecraft.banner.stripe_right.light_blue": "Palu zurdu azul claru",
  "block.minecraft.banner.stripe_right.light_gray": "Palu zurdu pedrés claru",
  "block.minecraft.banner.stripe_right.lime": "Palu zurdu verdi lima",
  "block.minecraft.banner.stripe_right.magenta": "Palu zurdu magenta",
  "block.minecraft.banner.stripe_right.orange": "Palu zurdu naranja",
  "block.minecraft.banner.stripe_right.pink": "Palu zurdu rosa",
  "block.minecraft.banner.stripe_right.purple": "Palu zurdu moráu",
  "block.minecraft.banner.stripe_right.red": "Palu zurdu encarnáu",
  "block.minecraft.banner.stripe_right.white": "Palu zurdu brancu",
  "block.minecraft.banner.stripe_right.yellow": "Palu zurdu amarillu",
  "block.minecraft.banner.stripe_top.black": "Terciu altu negru",
  "block.minecraft.banner.stripe_top.blue": "Terciu altu azul",
  "block.minecraft.banner.stripe_top.brown": "Terciu altu pardu",
  "block.minecraft.banner.stripe_top.cyan": "Terciu altu cian",
  "block.minecraft.banner.stripe_top.gray": "Terciu altu pedrés",
  "block.minecraft.banner.stripe_top.green": "Terciu altu verdi",
  "block.minecraft.banner.stripe_top.light_blue": "Terciu altu azul claru",
  "block.minecraft.banner.stripe_top.light_gray": "Terciu altu pedrés claru",
  "block.minecraft.banner.stripe_top.lime": "Terciu altu verdi lima",
  "block.minecraft.banner.stripe_top.magenta": "Terciu altu magenta",
  "block.minecraft.banner.stripe_top.orange": "Terciu altu naranja",
  "block.minecraft.banner.stripe_top.pink": "Terciu altu rosa",
  "block.minecraft.banner.stripe_top.purple": "Terciu altu moráu",
  "block.minecraft.banner.stripe_top.red": "Terciu altu encarnáu",
  "block.minecraft.banner.stripe_top.white": "Terciu altu brancu",
  "block.minecraft.banner.stripe_top.yellow": "Terciu altu amarillu",
  "block.minecraft.banner.triangle_bottom.black": "Picu negru",
  "block.minecraft.banner.triangle_bottom.blue": "Picu azul",
  "block.minecraft.banner.triangle_bottom.brown": "Picu pardu",
  "block.minecraft.banner.triangle_bottom.cyan": "Picu cian",
  "block.minecraft.banner.triangle_bottom.gray": "Picu pedrés",
  "block.minecraft.banner.triangle_bottom.green": "Picu verdi",
  "block.minecraft.banner.triangle_bottom.light_blue": "Picu azul claru",
  "block.minecraft.banner.triangle_bottom.light_gray": "Picu pedrés claru",
  "block.minecraft.banner.triangle_bottom.lime": "Picu verdi lima",
  "block.minecraft.banner.triangle_bottom.magenta": "Picu magenta",
  "block.minecraft.banner.triangle_bottom.orange": "Picu naranja",
  "block.minecraft.banner.triangle_bottom.pink": "Picu rosa",
  "block.minecraft.banner.triangle_bottom.purple": "Picu moráu",
  "block.minecraft.banner.triangle_bottom.red": "Picu encarnáu",
  "block.minecraft.banner.triangle_bottom.white": "Picu brancu",
  "block.minecraft.banner.triangle_bottom.yellow": "Picu amarillu",
  "block.minecraft.banner.triangle_top.black": "Picu altu negru",
  "block.minecraft.banner.triangle_top.blue": "Picu altu azul",
  "block.minecraft.banner.triangle_top.brown": "Picu altu pardu",
  "block.minecraft.banner.triangle_top.cyan": "Picu altu cian",
  "block.minecraft.banner.triangle_top.gray": "Picu altu pedrés",
  "block.minecraft.banner.triangle_top.green": "Picu altu verdi",
  "block.minecraft.banner.triangle_top.light_blue": "Picu altu azul claru",
  "block.minecraft.banner.triangle_top.light_gray": "Picu altu pedrés claru",
  "block.minecraft.banner.triangle_top.lime": "Picu altu verdi lima",
  "block.minecraft.banner.triangle_top.magenta": "Picu altu magenta",
  "block.minecraft.banner.triangle_top.orange": "Picu altu naranja",
  "block.minecraft.banner.triangle_top.pink": "Picu altu rosa",
  "block.minecraft.banner.triangle_top.purple": "Picu altu moráu",
  "block.minecraft.banner.triangle_top.red": "Picu altu encarnáu",
  "block.minecraft.banner.triangle_top.white": "Picu altu brancu",
  "block.minecraft.banner.triangle_top.yellow": "Picu altu amarillu",
  "block.minecraft.banner.triangles_bottom.black": "Dentáu negru'n basi",
  "block.minecraft.banner.triangles_bottom.blue": "Dentáu azul en basi",
  "block.minecraft.banner.triangles_bottom.brown": "Dentáu pardu'n basi",
  "block.minecraft.banner.triangles_bottom.cyan": "Dentáu cian en basi",
  "block.minecraft.banner.triangles_bottom.gray": "Dentáu pedrés en basi",
  "block.minecraft.banner.triangles_bottom.green": "Dentáu verdi'n basi",
  "block.minecraft.banner.triangles_bottom.light_blue": "Dentáu azul claru'n basi",
  "block.minecraft.banner.triangles_bottom.light_gray": "Dentáu pedrés claru'n basi",
  "block.minecraft.banner.triangles_bottom.lime": "Dentáu verdi lima'n basi",
  "block.minecraft.banner.triangles_bottom.magenta": "Dentáu magenta'n basi",
  "block.minecraft.banner.triangles_bottom.orange": "Dentáu naranja'n basi",
  "block.minecraft.banner.triangles_bottom.pink": "Dentáu rosa'n basi",
  "block.minecraft.banner.triangles_bottom.purple": "Dentáu moráu'n basi",
  "block.minecraft.banner.triangles_bottom.red": "Dentáu encarnáu'n basi",
  "block.minecraft.banner.triangles_bottom.white": "Dentáu brancu'n basi",
  "block.minecraft.banner.triangles_bottom.yellow": "Dentáu amarillu'n basi",
  "block.minecraft.banner.triangles_top.black": "Dentáu negru",
  "block.minecraft.banner.triangles_top.blue": "Dentáu azul",
  "block.minecraft.banner.triangles_top.brown": "Dentáu pardu",
  "block.minecraft.banner.triangles_top.cyan": "Dentáu cian",
  "block.minecraft.banner.triangles_top.gray": "Dentáu pedrés",
  "block.minecraft.banner.triangles_top.green": "Dentáu verdi",
  "block.minecraft.banner.triangles_top.light_blue": "Dentáu azul claru",
  "block.minecraft.banner.triangles_top.light_gray": "Dentáu pedrés claru",
  "block.minecraft.banner.triangles_top.lime": "Dentáu verdi lima",
  "block.minecraft.banner.triangles_top.magenta": "Dentáu magenta",
  "block.minecraft.banner.triangles_top.orange": "Dentáu naranja",
  "block.minecraft.banner.triangles_top.pink": "Dentáu rosa",
  "block.minecraft.banner.triangles_top.purple": "Dentáu moráu",
  "block.minecraft.banner.triangles_top.red": "Dentáu encarnáu",
  "block.minecraft.banner.triangles_top.white": "Dentáu brancu",
  "block.minecraft.banner.triangles_top.yellow": "Dentáu amarillu",
  "block.minecraft.barrel": "Barril",
  "block.minecraft.barrier": "Barrera",
  "block.minecraft.basalt": "Basaltu",
  "block.minecraft.beacon": "Faru",
  "block.minecraft.beacon.primary": "Poer principal",
  "block.minecraft.beacon.secondary": "Poer secundariu",
  "block.minecraft.bed.no_sleep": "Solu puéis durmir pola nochi u enos trubonis",
  "block.minecraft.bed.not_safe": "Nu puéis durmir abora, hai mostruos cerca",
  "block.minecraft.bed.obstructed": "Esta cama está ustruida",
  "block.minecraft.bed.occupied": "Esta cama está acupáa",
  "block.minecraft.bed.too_far_away": "Nu puéis durmir abora, la cama está mu lejos",
  "block.minecraft.bedrock": "Bedrock",
  "block.minecraft.bee_nest": "Ñial d'abejas",
  "block.minecraft.beehive": "Duju",
  "block.minecraft.beetroots": "Remolachas",
  "block.minecraft.bell": "Campanu",
  "block.minecraft.big_dripleaf": "Plantaforma grandi",
  "block.minecraft.big_dripleaf_stem": "Armuellu de plantaforma grandi",
  "block.minecraft.birch_button": "Butón d'abidul",
  "block.minecraft.birch_door": "Puerta d'abidul",
  "block.minecraft.birch_fence": "Cierru d'abidul",
  "block.minecraft.birch_fence_gate": "Purtillu d'abidul",
  "block.minecraft.birch_hanging_sign": "Endicaor colganti d'abidul",
  "block.minecraft.birch_leaves": "Jueyas d'abidul",
  "block.minecraft.birch_log": "Tueru d'abidul",
  "block.minecraft.birch_planks": "Tablonis d'abidul",
  "block.minecraft.birch_pressure_plate": "Placa' prisión d'abidul",
  "block.minecraft.birch_sapling": "Armuellu d'abidul",
  "block.minecraft.birch_shelf": "Balda d'abidul",
  "block.minecraft.birch_sign": "Endicaor d'abidul",
  "block.minecraft.birch_slab": "Llosa d'abidul",
  "block.minecraft.birch_stairs": "Escaleras d'abidul",
  "block.minecraft.birch_trapdoor": "Puirtuca d'abidul",
  "block.minecraft.birch_wall_hanging_sign": "Endicaor colganti d'abidul en pader",
  "block.minecraft.birch_wall_sign": "Endicaor d'abidul en pader",
  "block.minecraft.birch_wood": "Maera d'abidul",
  "block.minecraft.black_banner": "Estandarti negru",
  "block.minecraft.black_bed": "Cama negra",
  "block.minecraft.black_candle": "Vela negra",
  "block.minecraft.black_candle_cake": "Tarta con vela negra",
  "block.minecraft.black_carpet": "Alfombra negra",
  "block.minecraft.black_concrete": "Jormigón negru",
  "block.minecraft.black_concrete_powder": "Cementru negru",
  "block.minecraft.black_glazed_terracotta": "Azuleju negru",
  "block.minecraft.black_shulker_box": "Caja shulker negru",
  "block.minecraft.black_stained_glass": "Cristal tintáu de negru",
  "block.minecraft.black_stained_glass_pane": "Panel de cristal tintáu de negru",
  "block.minecraft.black_terracotta": "Terracota negru",
  "block.minecraft.black_wool": "Lana negru",
  "block.minecraft.blackstone": "Garma negru",
  "block.minecraft.blackstone_slab": "Llosa de garma negru",
  "block.minecraft.blackstone_stairs": "Escalonis de garma negru",
  "block.minecraft.blackstone_wall": "Moriu de garma negru",
  "block.minecraft.blast_furnace": "Altu jornu",
  "block.minecraft.blue_banner": "Estandarti azul",
  "block.minecraft.blue_bed": "Cama azul",
  "block.minecraft.blue_candle": "Vela azul",
  "block.minecraft.blue_candle_cake": "Tarta con vela azul",
  "block.minecraft.blue_carpet": "Alfombra azul",
  "block.minecraft.blue_concrete": "Jormigón azul",
  "block.minecraft.blue_concrete_powder": "Cementru azul",
  "block.minecraft.blue_glazed_terracotta": "Azuleju azul",
  "block.minecraft.blue_ice": "Helu azul",
  "block.minecraft.blue_orchid": "Urquídea azul",
  "block.minecraft.blue_shulker_box": "Caja shulker azul",
  "block.minecraft.blue_stained_glass": "Cristal tintáu de azul",
  "block.minecraft.blue_stained_glass_pane": "Panel de cristal tintáu de azul",
  "block.minecraft.blue_terracotta": "Terracota azul",
  "block.minecraft.blue_wool": "Lana azul",
  "block.minecraft.bone_block": "Bloqui de güesu",
  "block.minecraft.bookshelf": "Libriría",
  "block.minecraft.brain_coral": "Coral de celebru",
  "block.minecraft.brain_coral_block": "Bloqui de coral de celebru",
  "block.minecraft.brain_coral_fan": "Abanicu de coral de celebru",
  "block.minecraft.brain_coral_wall_fan": "Abanicu de coral de celebru'n pader",
  "block.minecraft.brewing_stand": "Soporti de berbajos",
  "block.minecraft.brick_slab": "Llosa de ladrillu",
  "block.minecraft.brick_stairs": "Escalonis de ladrillu",
  "block.minecraft.brick_wall": "Moriu de ladrillu",
  "block.minecraft.bricks": "Ladrillu",
  "block.minecraft.brown_banner": "Estandarti pardu",
  "block.minecraft.brown_bed": "Cama parda",
  "block.minecraft.brown_candle": "Vela parda",
  "block.minecraft.brown_candle_cake": "Tarta con vela parda",
  "block.minecraft.brown_carpet": "Alfombra parda",
  "block.minecraft.brown_concrete": "Jormigón pardu",
  "block.minecraft.brown_concrete_powder": "Cementru pardu",
  "block.minecraft.brown_glazed_terracotta": "Azuleju pardu",
  "block.minecraft.brown_mushroom": "Jongu pardu",
  "block.minecraft.brown_mushroom_block": "Bloqui de jongu pardu",
  "block.minecraft.brown_shulker_box": "Caja shulker parda",
  "block.minecraft.brown_stained_glass": "Cristal tintáu de pardu",
  "block.minecraft.brown_stained_glass_pane": "Panel de cristal tintáu de pardu",
  "block.minecraft.brown_terracotta": "Terracota pardu",
  "block.minecraft.brown_wool": "Lana pardu",
  "block.minecraft.bubble_column": "Columna de gurgulitos",
  "block.minecraft.bubble_coral": "Coral de gurgulitu",
  "block.minecraft.bubble_coral_block": "Bloqui de coral de gurgulitu",
  "block.minecraft.bubble_coral_fan": "Abanicu de coral de gurgulitu",
  "block.minecraft.bubble_coral_wall_fan": "Abanicu de coral de gurgulitu'n pader",
  "block.minecraft.budding_amethyst": "Bloqui d'amatista nacienti",
  "block.minecraft.bush": "Sietu",
  "block.minecraft.cactus": "Catus",
  "block.minecraft.cactus_flower": "Jlor de catus",
  "block.minecraft.cake": "Tarta",
  "block.minecraft.calcite": "Calcita",
  "block.minecraft.calibrated_sculk_sensor": "Sensor de sculk calibráu",
  "block.minecraft.campfire": "Lumbrera",
  "block.minecraft.candle": "Vela",
  "block.minecraft.candle_cake": "Tarta con vela",
  "block.minecraft.carrots": "Acenorias",
  "block.minecraft.cartography_table": "Mesa de cartografía",
  "block.minecraft.carved_pumpkin": "Calabaza cortáa",
  "block.minecraft.cauldron": "Tangarru",
  "block.minecraft.cave_air": "Airi de coviyu",
  "block.minecraft.cave_vines": "Enredaera de coviyu",
  "block.minecraft.cave_vines_plant": "Planta d'enredaeras de coviyu",
  "block.minecraft.chain": "Caena de jierru",
  "block.minecraft.chain_command_block": "Bloqui de comandos en caena",
  "block.minecraft.cherry_button": "Butón de cerezu",
  "block.minecraft.cherry_door": "Puerta de cerezu",
  "block.minecraft.cherry_fence": "Cierru de cerezu",
  "block.minecraft.cherry_fence_gate": "Purtillu de cerezu",
  "block.minecraft.cherry_hanging_sign": "Endicaor colganti de cerezu",
  "block.minecraft.cherry_leaves": "Jueyas de cerezu",
  "block.minecraft.cherry_log": "Tueru de cerezu",
  "block.minecraft.cherry_planks": "Tablonis de cerezu",
  "block.minecraft.cherry_pressure_plate": "Placa' prisión de cerezu",
  "block.minecraft.cherry_sapling": "Armuellu de cerezu",
  "block.minecraft.cherry_shelf": "Balda de cerezu",
  "block.minecraft.cherry_sign": "Endicaor de cerezu",
  "block.minecraft.cherry_slab": "Llosa de cerezu",
  "block.minecraft.cherry_stairs": "Escaleras de cerezu",
  "block.minecraft.cherry_trapdoor": "Puirtuca de cerezu",
  "block.minecraft.cherry_wall_hanging_sign": "Endicaor colganti de cerezu'n pader",
  "block.minecraft.cherry_wall_sign": "Endicaor de cerezu'n pader",
  "block.minecraft.cherry_wood": "Maera de cerezu",
  "block.minecraft.chest": "Baúl",
  "block.minecraft.chipped_anvil": "Unqui rotu",
  "block.minecraft.chiseled_bookshelf": "Istantería",
  "block.minecraft.chiseled_copper": "Cobri cinceláu",
  "block.minecraft.chiseled_deepslate": "Pizarra cinceláu",
  "block.minecraft.chiseled_nether_bricks": "Ladrillu del Nether cinceláu",
  "block.minecraft.chiseled_polished_blackstone": "Garma negru pulíu cinceláu",
  "block.minecraft.chiseled_quartz_block": "Cuarzu cinceláu",
  "block.minecraft.chiseled_red_sandstone": "Ariniza encarnáu cinceláu",
  "block.minecraft.chiseled_resin_bricks": "Ladrillu de risina cinceláu",
  "block.minecraft.chiseled_sandstone": "Ariniza cinceláu",
  "block.minecraft.chiseled_stone_bricks": "Ladrillu de garma cinceláu",
  "block.minecraft.chiseled_tuff": "Toba cinceláu",
  "block.minecraft.chiseled_tuff_bricks": "Ladrillu de toba cinceláu",
  "block.minecraft.chorus_flower": "Jlor coru",
  "block.minecraft.chorus_plant": "Planta coru",
  "block.minecraft.clay": "Bloqui d'arcilla",
  "block.minecraft.closed_eyeblossom": "Mirajlor cerráa",
  "block.minecraft.coal_block": "Bloqui de carbón",
  "block.minecraft.coal_ore": "Mena de carbón",
  "block.minecraft.coarse_dirt": "Tierra apalambráa",
  "block.minecraft.cobbled_deepslate": "Pizarra encacháu",
  "block.minecraft.cobbled_deepslate_slab": "Llosa de pizarra encacháu",
  "block.minecraft.cobbled_deepslate_stairs": "Escalonis de pizarra encacháu",
  "block.minecraft.cobbled_deepslate_wall": "Moriu de pizarra encacháu",
  "block.minecraft.cobblestone": "Aduquín",
  "block.minecraft.cobblestone_slab": "Llosa d'aduquín",
  "block.minecraft.cobblestone_stairs": "Escalonis d'aduquín",
  "block.minecraft.cobblestone_wall": "Moriu d'aduquín",
  "block.minecraft.cobweb": "Telaraña",
  "block.minecraft.cocoa": "Cacau",
  "block.minecraft.command_block": "Bloqui de comandu",
  "block.minecraft.comparator": "Comparaor de redstone",
  "block.minecraft.composter": "Compostaor",
  "block.minecraft.conduit": "Cundutu",
  "block.minecraft.copper_bars": "Barrotis de cobri",
  "block.minecraft.copper_block": "Bloqui de cobri",
  "block.minecraft.copper_bulb": "Bumbillu de cobri",
  "block.minecraft.copper_chain": "Caena de cobri",
  "block.minecraft.copper_chest": "Baúl de cobri",
  "block.minecraft.copper_door": "Puerta de cobri",
  "block.minecraft.copper_golem_statue": "Estatua de gólem de cobri",
  "block.minecraft.copper_grate": "Rijillu de cobri",
  "block.minecraft.copper_lantern": "Farulucu de cobri",
  "block.minecraft.copper_ore": "Mena de cobri",
  "block.minecraft.copper_torch": "Aja de cobri",
  "block.minecraft.copper_trapdoor": "Puirtuca de cobri",
  "block.minecraft.copper_wall_torch": "Aja de cobri'n pader",
  "block.minecraft.cornflower": "Acianu",
  "block.minecraft.cracked_deepslate_bricks": "Ladrillu de pizarra rotu",
  "block.minecraft.cracked_deepslate_tiles": "Baldosa de pizarra rotu",
  "block.minecraft.cracked_nether_bricks": "Ladrillu del Nether rotu",
  "block.minecraft.cracked_polished_blackstone_bricks": "Ladrillu de garma negru pulíu rotu",
  "block.minecraft.cracked_stone_bricks": "Ladrillu de garma rotu",
  "block.minecraft.crafter": "Jabricaor",
  "block.minecraft.crafting_table": "Mesa de trebaju",
  "block.minecraft.creaking_heart": "Corazón de crepitanti",
  "block.minecraft.creeper_head": "Zamosta de creeper",
  "block.minecraft.creeper_wall_head": "Zamosta de creeper en pader",
  "block.minecraft.crimson_button": "Butón carmesín",
  "block.minecraft.crimson_door": "Puerta carmesín",
  "block.minecraft.crimson_fence": "Cierru carmesín",
  "block.minecraft.crimson_fence_gate": "Purtillu carmesín",
  "block.minecraft.crimson_fungus": "Jongu carmesín",
  "block.minecraft.crimson_hanging_sign": "Endicaor colganti carmesín",
  "block.minecraft.crimson_hyphae": "Hifas carmesín",
  "block.minecraft.crimson_nylium": "Niliu carmesín",
  "block.minecraft.crimson_planks": "Tablonis carmesín",
  "block.minecraft.crimson_pressure_plate": "Placa' prisión carmesín",
  "block.minecraft.crimson_roots": "Raicis carmesín",
  "block.minecraft.crimson_shelf": "Balda carmesín",
  "block.minecraft.crimson_sign": "Endicaor carmesín",
  "block.minecraft.crimson_slab": "Llosa carmesín",
  "block.minecraft.crimson_stairs": "Escaleras carmesín",
  "block.minecraft.crimson_stem": "Tayu carmesín",
  "block.minecraft.crimson_trapdoor": "Puirtuca carmesín",
  "block.minecraft.crimson_wall_hanging_sign": "Endicaor colganti carmesín en pader",
  "block.minecraft.crimson_wall_sign": "Endicaor carmesín en pader",
  "block.minecraft.crying_obsidian": "Osidiana murniosu",
  "block.minecraft.cut_copper": "Cobri cortáu",
  "block.minecraft.cut_copper_slab": "Llosa de cobri cortáu",
  "block.minecraft.cut_copper_stairs": "Escalonis de cobri cortáu",
  "block.minecraft.cut_red_sandstone": "Ariniza encarnáu cortáu",
  "block.minecraft.cut_red_sandstone_slab": "Llosa d'ariniza encarnáu cortáu",
  "block.minecraft.cut_sandstone": "Ariniza cortáu",
  "block.minecraft.cut_sandstone_slab": "Llosa d'ariniza cortáu",
  "block.minecraft.cyan_banner": "Estandarti cian",
  "block.minecraft.cyan_bed": "Cama cian",
  "block.minecraft.cyan_candle": "Vela cian",
  "block.minecraft.cyan_candle_cake": "Tarta con vela cian",
  "block.minecraft.cyan_carpet": "Alfombra cian",
  "block.minecraft.cyan_concrete": "Jormigón cian",
  "block.minecraft.cyan_concrete_powder": "Cementru cian",
  "block.minecraft.cyan_glazed_terracotta": "Azuleju cian",
  "block.minecraft.cyan_shulker_box": "Caja shulker cian",
  "block.minecraft.cyan_stained_glass": "Cristal tintáu de cian",
  "block.minecraft.cyan_stained_glass_pane": "Panel de cristal tintáu de cian",
  "block.minecraft.cyan_terracotta": "Terracota cian",
  "block.minecraft.cyan_wool": "Lana cian",
  "block.minecraft.damaged_anvil": "Unqui jeringáu",
  "block.minecraft.dandelion": "Piscondia",
  "block.minecraft.dark_oak_button": "Butón de cajiga escuru",
  "block.minecraft.dark_oak_door": "Puerta de cajiga escuru",
  "block.minecraft.dark_oak_fence": "Cierru de cajiga escuru",
  "block.minecraft.dark_oak_fence_gate": "Purtillu de cajiga escuru",
  "block.minecraft.dark_oak_hanging_sign": "Endicaor colganti de cajiga escuru",
  "block.minecraft.dark_oak_leaves": "Jueyas de cajiga escuru",
  "block.minecraft.dark_oak_log": "Tueru de cajiga escuru",
  "block.minecraft.dark_oak_planks": "Tablonis de cajiga escuru",
  "block.minecraft.dark_oak_pressure_plate": "Placa' prisión de cajiga escuru",
  "block.minecraft.dark_oak_sapling": "Armuellu de cajiga escuru",
  "block.minecraft.dark_oak_shelf": "Balda de cajiga escuru",
  "block.minecraft.dark_oak_sign": "Endicaor de cajiga escuru",
  "block.minecraft.dark_oak_slab": "Llosa de cajiga escuru",
  "block.minecraft.dark_oak_stairs": "Escaleras de cajiga escuru",
  "block.minecraft.dark_oak_trapdoor": "Puirtuca de cajiga escuru",
  "block.minecraft.dark_oak_wall_hanging_sign": "Endicaor colganti de cajiga escuru'n pader",
  "block.minecraft.dark_oak_wall_sign": "Endicaor de cajiga escuru'n pader",
  "block.minecraft.dark_oak_wood": "Maera de cajiga escuru",
  "block.minecraft.dark_prismarine": "Prismarina escuru",
  "block.minecraft.dark_prismarine_slab": "Llosa de prismarina escuru",
  "block.minecraft.dark_prismarine_stairs": "Escalonis de prismarina escuru",
  "block.minecraft.daylight_detector": "Panel solar",
  "block.minecraft.dead_brain_coral": "Coral de celebru muríu",
  "block.minecraft.dead_brain_coral_block": "Bloqui de coral de celebru muríu",
  "block.minecraft.dead_brain_coral_fan": "Abanicu de coral de celebru muríu",
  "block.minecraft.dead_brain_coral_wall_fan": "Abanicu de coral de celebru muríu'n pader",
  "block.minecraft.dead_bubble_coral": "Coral de gurgulitu muríu",
  "block.minecraft.dead_bubble_coral_block": "Bloqui de coral de gurgulitu muríu",
  "block.minecraft.dead_bubble_coral_fan": "Abanicu de coral de gurgulitu muríu",
  "block.minecraft.dead_bubble_coral_wall_fan": "Abanicu de coral de gurgulitu muríu'n pader",
  "block.minecraft.dead_bush": "Sietu ataláu",
  "block.minecraft.dead_fire_coral": "Coral de fuegu muríu",
  "block.minecraft.dead_fire_coral_block": "Bloqui de coral de fuegu muríu",
  "block.minecraft.dead_fire_coral_fan": "Abanicu de coral de fuegu muríu",
  "block.minecraft.dead_fire_coral_wall_fan": "Abanicu de coral de fuegu muríu'n pader",
  "block.minecraft.dead_horn_coral": "Coral de buji muríu",
  "block.minecraft.dead_horn_coral_block": "Bloqui de coral de buji muríu",
  "block.minecraft.dead_horn_coral_fan": "Abanicu de coral de buji muríu",
  "block.minecraft.dead_horn_coral_wall_fan": "Abanicu de coral de buje muríu'n pader",
  "block.minecraft.dead_tube_coral": "Coral de tubu muríu",
  "block.minecraft.dead_tube_coral_block": "Bloqui de coral de tubu muríu",
  "block.minecraft.dead_tube_coral_fan": "Abanicu de coral de tubu muríu",
  "block.minecraft.dead_tube_coral_wall_fan": "Abanicu de coral de tubu muríu'n pader",
  "block.minecraft.decorated_pot": "Cancarru decoráu",
  "block.minecraft.deepslate": "Pizarra",
  "block.minecraft.deepslate_brick_slab": "Llosa de ladrillu de pizarra",
  "block.minecraft.deepslate_brick_stairs": "Escalonis de ladrillu de pizarra",
  "block.minecraft.deepslate_brick_wall": "Moriu de ladrillu de pizarra",
  "block.minecraft.deepslate_bricks": "Ladrillu de pizarra",
  "block.minecraft.deepslate_coal_ore": "Mena de carbón jondu",
  "block.minecraft.deepslate_copper_ore": "Mena de cobri jondu",
  "block.minecraft.deepslate_diamond_ore": "Mena de diamanti jondu",
  "block.minecraft.deepslate_emerald_ore": "Mena d'esmeralda jondu",
  "block.minecraft.deepslate_gold_ore": "Mena d'oru jondu",
  "block.minecraft.deepslate_iron_ore": "Mena de jierru jondu",
  "block.minecraft.deepslate_lapis_ore": "Mena de lapislázuli jondu",
  "block.minecraft.deepslate_redstone_ore": "Mena de redstone jondu",
  "block.minecraft.deepslate_tile_slab": "Llosa de baldosa de pizarra",
  "block.minecraft.deepslate_tile_stairs": "Escalonis de baldosa de pizarra",
  "block.minecraft.deepslate_tile_wall": "Moriu de baldosa de pizarra",
  "block.minecraft.deepslate_tiles": "Baldosa de pizarra",
  "block.minecraft.detector_rail": "Raíl detetor",
  "block.minecraft.diamond_block": "Bloqui de diamanti",
  "block.minecraft.diamond_ore": "Mena de diamanti",
  "block.minecraft.diorite": "Diurita",
  "block.minecraft.diorite_slab": "Llosa de diurita",
  "block.minecraft.diorite_stairs": "Escalonis de diurita",
  "block.minecraft.diorite_wall": "Moriu de diurita",
  "block.minecraft.dirt": "Tierra",
  "block.minecraft.dirt_path": "Cambera de tierra",
  "block.minecraft.dispenser": "Dispensaor",
  "block.minecraft.dragon_egg": "Güevu de dragón",
  "block.minecraft.dragon_head": "Zamosta de dragón",
  "block.minecraft.dragon_wall_head": "Zamosta de dragón en pader",
  "block.minecraft.dried_ghast": "Ghast ataláu",
  "block.minecraft.dried_kelp_block": "Bloqui de caloca ataláu",
  "block.minecraft.dripstone_block": "Bloqui de caliza",
  "block.minecraft.dropper": "Soltaor",
  "block.minecraft.emerald_block": "Bloqui d'esmeralda",
  "block.minecraft.emerald_ore": "Mena d'esmeralda",
  "block.minecraft.enchanting_table": "Mesa de jichizos",
  "block.minecraft.end_gateway": "Nexu del End",
  "block.minecraft.end_portal": "Portal del End",
  "block.minecraft.end_portal_frame": "Marcu del portal del End",
  "block.minecraft.end_rod": "Caña del End",
  "block.minecraft.end_stone": "Garma del End",
  "block.minecraft.end_stone_brick_slab": "Llosa de ladrillu del End",
  "block.minecraft.end_stone_brick_stairs": "Escalonis de ladrillu del End",
  "block.minecraft.end_stone_brick_wall": "Moriu de ladrillu del End",
  "block.minecraft.end_stone_bricks": "Ladrillu del End",
  "block.minecraft.ender_chest": "Baúl d'ender",
  "block.minecraft.exposed_chiseled_copper": "Cobri cinceláu espuestu",
  "block.minecraft.exposed_copper": "Cobri espuestu",
  "block.minecraft.exposed_copper_bars": "Barrotis de cobri espuestu",
  "block.minecraft.exposed_copper_bulb": "Bumbillu de cobri espuestu",
  "block.minecraft.exposed_copper_chain": "Caena de cobri espuestu",
  "block.minecraft.exposed_copper_chest": "Baúl de cobri espuestu",
  "block.minecraft.exposed_copper_door": "Puerta de cobri espuestu",
  "block.minecraft.exposed_copper_golem_statue": "Estatua de gólem de cobri espuestu",
  "block.minecraft.exposed_copper_grate": "Rijillu de cobri espuestu",
  "block.minecraft.exposed_copper_lantern": "Farulucu de cobri espuestu",
  "block.minecraft.exposed_copper_trapdoor": "Puirtuca de cobri espuestu",
  "block.minecraft.exposed_cut_copper": "Cobri cortáu espuestu",
  "block.minecraft.exposed_cut_copper_slab": "Llosa de cobri cortáu espuestu",
  "block.minecraft.exposed_cut_copper_stairs": "Escalonis de cobri cortáu espuestu",
  "block.minecraft.exposed_lightning_rod": "Pararrayos espuestu",
  "block.minecraft.farmland": "Güertu",
  "block.minecraft.fern": "Jelechu",
  "block.minecraft.fire": "Lumbri",
  "block.minecraft.fire_coral": "Coral de fuegu",
  "block.minecraft.fire_coral_block": "Bloqui de coral de fuegu",
  "block.minecraft.fire_coral_fan": "Abanicu de coral de fuegu",
  "block.minecraft.fire_coral_wall_fan": "Abanicu de coral de fuegu'n pader",
  "block.minecraft.firefly_bush": "Sietu de luceras",
  "block.minecraft.fletching_table": "Mesa de flechas",
  "block.minecraft.flower_pot": "Tiestu",
  "block.minecraft.flowering_azalea": "Azalea campizáu",
  "block.minecraft.flowering_azalea_leaves": "Jueyas d'azalea campizáu",
  "block.minecraft.frogspawn": "Güevos de salonquia",
  "block.minecraft.frosted_ice": "Yelu escarcháu",
  "block.minecraft.furnace": "Jornu",
  "block.minecraft.gilded_blackstone": "Garma negru doráu",
  "block.minecraft.glass": "Cristal",
  "block.minecraft.glass_pane": "Panel de cristal",
  "block.minecraft.glow_lichen": "Liqui estelanti",
  "block.minecraft.glowstone": "Garma estelanti",
  "block.minecraft.gold_block": "Bloqui d'oru",
  "block.minecraft.gold_ore": "Mena d'oru",
  "block.minecraft.golden_dandelion": "Churracamas doráu",
  "block.minecraft.granite": "Granitu",
  "block.minecraft.granite_slab": "Llosa de granitu",
  "block.minecraft.granite_stairs": "Escalonis de granitu",
  "block.minecraft.granite_wall": "Moriu de granitu",
  "block.minecraft.grass": "Herba",
  "block.minecraft.grass_block": "Tapín",
  "block.minecraft.gravel": "Grija",
  "block.minecraft.gray_banner": "Estandarti pedrés",
  "block.minecraft.gray_bed": "Cama pedrés",
  "block.minecraft.gray_candle": "Vela pedrés",
  "block.minecraft.gray_candle_cake": "Tarta con vela pedrés",
  "block.minecraft.gray_carpet": "Alfombra pedrés",
  "block.minecraft.gray_concrete": "Jormigón pedrés",
  "block.minecraft.gray_concrete_powder": "Cementru pedrés",
  "block.minecraft.gray_glazed_terracotta": "Azuleju pedrés",
  "block.minecraft.gray_shulker_box": "Caja shulker pedrés",
  "block.minecraft.gray_stained_glass": "Cristal pedrés",
  "block.minecraft.gray_stained_glass_pane": "Panel de cristal pedrés",
  "block.minecraft.gray_terracotta": "Terracota pedrés",
  "block.minecraft.gray_wool": "Lana pedrés",
  "block.minecraft.green_banner": "Estandarti verdi",
  "block.minecraft.green_bed": "Cama verdi",
  "block.minecraft.green_candle": "Vela verdi",
  "block.minecraft.green_candle_cake": "Tarta con vela verdi",
  "block.minecraft.green_carpet": "Alfombra verdi",
  "block.minecraft.green_concrete": "Jormigón verdi",
  "block.minecraft.green_concrete_powder": "Cementru verdi",
  "block.minecraft.green_glazed_terracotta": "Azuleju verdi",
  "block.minecraft.green_shulker_box": "Caja shulker verdi",
  "block.minecraft.green_stained_glass": "Cristal verdi",
  "block.minecraft.green_stained_glass_pane": "Panel de cristal verdi",
  "block.minecraft.green_terracotta": "Terracota verdi",
  "block.minecraft.green_wool": "Lana verdi",
  "block.minecraft.grindstone": "Amolachín",
  "block.minecraft.hanging_roots": "Raicis colgantis",
  "block.minecraft.hay_block": "Fardu de trigu",
  "block.minecraft.heavy_core": "Núcleu pesáu",
  "block.minecraft.heavy_weighted_pressure_plate": "Placa' prisión de jierru",
  "block.minecraft.honey_block": "Bloqui de miel",
  "block.minecraft.honeycomb_block": "Bloque de cera",
  "block.minecraft.hopper": "Tolva",
  "block.minecraft.horn_coral": "Coral de buji",
  "block.minecraft.horn_coral_block": "Bloqui de coral de buji",
  "block.minecraft.horn_coral_fan": "Abanicu de coral de buji",
  "block.minecraft.horn_coral_wall_fan": "Abanicu de coral de buji'n pader",
  "block.minecraft.ice": "Helu",
  "block.minecraft.infested_chiseled_stone_bricks": "Ladrillu de garma cinceláu infestáu",
  "block.minecraft.infested_cobblestone": "Aduquín infestáu",
  "block.minecraft.infested_cracked_stone_bricks": "Ladrillu de garma rotu infestáu",
  "block.minecraft.infested_deepslate": "Pizarra infestáu",
  "block.minecraft.infested_mossy_stone_bricks": "Ladrillu de garma con mugu infestáu",
  "block.minecraft.infested_stone": "Garma infestáu",
  "block.minecraft.infested_stone_bricks": "Ladrillu de garma infestáu",
  "block.minecraft.iron_bars": "Barrotis de jierru",
  "block.minecraft.iron_block": "Bloqui de jierru",
  "block.minecraft.iron_chain": "Caena de jierru",
  "block.minecraft.iron_door": "Puerta de jierru",
  "block.minecraft.iron_ore": "Mena de jierru",
  "block.minecraft.iron_trapdoor": "Puirtuca de jierru",
  "block.minecraft.jack_o_lantern": "Verrugona aterraora",
  "block.minecraft.jigsaw": "Bloqui rompicabezas",
  "block.minecraft.jukebox": "Tocadiscos",
  "block.minecraft.jungle_button": "Butón de jungla",
  "block.minecraft.jungle_door": "Puerta de jungla",
  "block.minecraft.jungle_fence": "Cierru de jungla",
  "block.minecraft.jungle_fence_gate": "Purtillu de jungla",
  "block.minecraft.jungle_hanging_sign": "Endicaor colganti de jungla",
  "block.minecraft.jungle_leaves": "Jueyas de jungla",
  "block.minecraft.jungle_log": "Tueru de jungla",
  "block.minecraft.jungle_planks": "Tablonis de jungla",
  "block.minecraft.jungle_pressure_plate": "Placa' prisión de jungla",
  "block.minecraft.jungle_sapling": "Armuellu de jungla",
  "block.minecraft.jungle_shelf": "Balda de jungla",
  "block.minecraft.jungle_sign": "Endicaor de jungla",
  "block.minecraft.jungle_slab": "Llosa de jungla",
  "block.minecraft.jungle_stairs": "Escaleras de jungla",
  "block.minecraft.jungle_trapdoor": "Puirtuca de jungla",
  "block.minecraft.jungle_wall_hanging_sign": "Endicaor colganti de jungla'n pader",
  "block.minecraft.jungle_wall_sign": "Endicaor de jungla'n pader",
  "block.minecraft.jungle_wood": "Maera de jungla",
  "block.minecraft.kelp": "Caloca",
  "block.minecraft.kelp_plant": "Caloca",
  "block.minecraft.ladder": "Iscaleruca de manu",
  "block.minecraft.lantern": "Farulillu",
  "block.minecraft.lapis_block": "Bloqui de lapislázuli",
  "block.minecraft.lapis_ore": "Mena de lapislázuli",
  "block.minecraft.large_amethyst_bud": "Broti d'amatista grandi",
  "block.minecraft.large_fern": "Jelechu grandi",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Tangarru con lava",
  "block.minecraft.leaf_litter": "Jueyas ensuchas",
  "block.minecraft.lectern": "Atril",
  "block.minecraft.lever": "Palancu",
  "block.minecraft.light": "Luz",
  "block.minecraft.light_blue_banner": "Estandarti azul claru",
  "block.minecraft.light_blue_bed": "Cama azul claru",
  "block.minecraft.light_blue_candle": "Vela azul claru",
  "block.minecraft.light_blue_candle_cake": "Tarta con vela azul claru",
  "block.minecraft.light_blue_carpet": "Alfombra azul claru",
  "block.minecraft.light_blue_concrete": "Jormigón azul claru",
  "block.minecraft.light_blue_concrete_powder": "Cementru azul claru",
  "block.minecraft.light_blue_glazed_terracotta": "Azuleju azul claru",
  "block.minecraft.light_blue_shulker_box": "Caja shulker azul claru",
  "block.minecraft.light_blue_stained_glass": "Cristal tintáu de azul claru",
  "block.minecraft.light_blue_stained_glass_pane": "Panel de cristal tintáu de azul claru",
  "block.minecraft.light_blue_terracotta": "Terracota azul claru",
  "block.minecraft.light_blue_wool": "Lana azul claru",
  "block.minecraft.light_gray_banner": "Estandarti pedrés claru",
  "block.minecraft.light_gray_bed": "Cama pedrés claru",
  "block.minecraft.light_gray_candle": "Vela pedrés claru",
  "block.minecraft.light_gray_candle_cake": "Tarta con vela pedrés claru",
  "block.minecraft.light_gray_carpet": "Alfombra pedrés claru",
  "block.minecraft.light_gray_concrete": "Jormigón pedrés claru",
  "block.minecraft.light_gray_concrete_powder": "Cementru pedrés claru",
  "block.minecraft.light_gray_glazed_terracotta": "Azuleju pedrés claru",
  "block.minecraft.light_gray_shulker_box": "Caja shulker pedrés claru",
  "block.minecraft.light_gray_stained_glass": "Cristal tintáu de pedrés claru",
  "block.minecraft.light_gray_stained_glass_pane": "Panel de cristal tintáu de pedrés claru",
  "block.minecraft.light_gray_terracotta": "Terracota pedrés claru",
  "block.minecraft.light_gray_wool": "Lana pedrés claru",
  "block.minecraft.light_weighted_pressure_plate": "Placa' prisión d'oru",
  "block.minecraft.lightning_rod": "Pararrayos",
  "block.minecraft.lilac": "Jarrumochu",
  "block.minecraft.lily_of_the_valley": "Perlengue de valli",
  "block.minecraft.lily_pad": "Ninúfar",
  "block.minecraft.lime_banner": "Estandarti verde lima",
  "block.minecraft.lime_bed": "Cama verdi lima",
  "block.minecraft.lime_candle": "Vela verdi lima",
  "block.minecraft.lime_candle_cake": "Tarta con vela verdi lima",
  "block.minecraft.lime_carpet": "Alfombra verdi lima",
  "block.minecraft.lime_concrete": "Jormigón verdi lima",
  "block.minecraft.lime_concrete_powder": "Cementru verdi lima",
  "block.minecraft.lime_glazed_terracotta": "Azuleju verdi lima",
  "block.minecraft.lime_shulker_box": "Caja shulker verdi lima",
  "block.minecraft.lime_stained_glass": "Cristal tintáu de verdi lima",
  "block.minecraft.lime_stained_glass_pane": "Panel de cristal tintáu de verdi lima",
  "block.minecraft.lime_terracotta": "Terracota verdi lima",
  "block.minecraft.lime_wool": "Lana verdi lima",
  "block.minecraft.lodestone": "Bloqui de magnitita",
  "block.minecraft.loom": "Telar",
  "block.minecraft.magenta_banner": "Estandarti magenta",
  "block.minecraft.magenta_bed": "Cama magenta",
  "block.minecraft.magenta_candle": "Vela magenta",
  "block.minecraft.magenta_candle_cake": "Tarta con vela magenta",
  "block.minecraft.magenta_carpet": "Alfombra magenta",
  "block.minecraft.magenta_concrete": "Jormigón magenta",
  "block.minecraft.magenta_concrete_powder": "Cementru magenta",
  "block.minecraft.magenta_glazed_terracotta": "Azuleju magenta",
  "block.minecraft.magenta_shulker_box": "Caja shulker magenta",
  "block.minecraft.magenta_stained_glass": "Cristal tintáu de magenta",
  "block.minecraft.magenta_stained_glass_pane": "Panel de cristal tintáu de magenta",
  "block.minecraft.magenta_terracotta": "Terracota magenta",
  "block.minecraft.magenta_wool": "Lana magenta",
  "block.minecraft.magma_block": "Bloqui de magma",
  "block.minecraft.mangrove_button": "Butón de mangli",
  "block.minecraft.mangrove_door": "Puerta de mangli",
  "block.minecraft.mangrove_fence": "Cierru de mangli",
  "block.minecraft.mangrove_fence_gate": "Purtillu de mangli",
  "block.minecraft.mangrove_hanging_sign": "Endicaor colganti de mangli",
  "block.minecraft.mangrove_leaves": "Jueyas de mangli",
  "block.minecraft.mangrove_log": "Tueru de mangli",
  "block.minecraft.mangrove_planks": "Tablonis de mangli",
  "block.minecraft.mangrove_pressure_plate": "Placa' prisión de mangli",
  "block.minecraft.mangrove_propagule": "Brena de mangli",
  "block.minecraft.mangrove_roots": "Raicis de mangli",
  "block.minecraft.mangrove_shelf": "Balda de mangli",
  "block.minecraft.mangrove_sign": "Endicaor de mangli",
  "block.minecraft.mangrove_slab": "Llosa de mangli",
  "block.minecraft.mangrove_stairs": "Escaleras de mangli",
  "block.minecraft.mangrove_trapdoor": "Puirtuca de mangli",
  "block.minecraft.mangrove_wall_hanging_sign": "Endicaor colganti de mangli'n pader",
  "block.minecraft.mangrove_wall_sign": "Endicaor de mangli'n pader",
  "block.minecraft.mangrove_wood": "Maera de mangli",
  "block.minecraft.medium_amethyst_bud": "Broti d'amatista",
  "block.minecraft.melon": "Sandía",
  "block.minecraft.melon_stem": "Tayu de sandía",
  "block.minecraft.moss_block": "Bloqui de mugu",
  "block.minecraft.moss_carpet": "Alfombra de mugu",
  "block.minecraft.mossy_cobblestone": "Aduquín con mugu",
  "block.minecraft.mossy_cobblestone_slab": "Llosa d'aduquín con mugu",
  "block.minecraft.mossy_cobblestone_stairs": "Escalonis d'aduquín con mugu",
  "block.minecraft.mossy_cobblestone_wall": "Moriu d'aduquín con mugu",
  "block.minecraft.mossy_stone_brick_slab": "Llosa de ladrillu de garma con mugu",
  "block.minecraft.mossy_stone_brick_stairs": "Escalonis de ladrillu de garma con mugu",
  "block.minecraft.mossy_stone_brick_wall": "Moriu de ladrillu de garma con mugu",
  "block.minecraft.mossy_stone_bricks": "Ladrillu de garma con mugu",
  "block.minecraft.moving_piston": "Pistón en muvimientu",
  "block.minecraft.mud": "Barru",
  "block.minecraft.mud_brick_slab": "Llosa de ladrillu de barru",
  "block.minecraft.mud_brick_stairs": "Escalonis de ladrillu de barru",
  "block.minecraft.mud_brick_wall": "Moriu de ladrillu de barru",
  "block.minecraft.mud_bricks": "Ladrillu de barru",
  "block.minecraft.muddy_mangrove_roots": "Raicis de mangli embarráu",
  "block.minecraft.mushroom_stem": "Tayu de jongu",
  "block.minecraft.mycelium": "Miceliu",
  "block.minecraft.nether_brick_fence": "Cierru de ladrillu del Nether",
  "block.minecraft.nether_brick_slab": "Llosa de ladrillu del Nether",
  "block.minecraft.nether_brick_stairs": "Escalonis de ladrillu del Nether",
  "block.minecraft.nether_brick_wall": "Moriu de ladrillu del Nether",
  "block.minecraft.nether_bricks": "Ladrillu del Nether",
  "block.minecraft.nether_gold_ore": "Mena d'oru del Nether",
  "block.minecraft.nether_portal": "Portal al Nether",
  "block.minecraft.nether_quartz_ore": "Mena de cuarzu",
  "block.minecraft.nether_sprouts": "Herbalatu del Nether",
  "block.minecraft.nether_wart": "Virruga del Nether",
  "block.minecraft.nether_wart_block": "Bloqui de virruga del Nether",
  "block.minecraft.netherite_block": "Bloqui de netherita",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Bloqui musical",
  "block.minecraft.oak_button": "Butón de cajiga",
  "block.minecraft.oak_door": "Puerta de cajiga",
  "block.minecraft.oak_fence": "Cierru de cajiga",
  "block.minecraft.oak_fence_gate": "Purtillu de cajiga",
  "block.minecraft.oak_hanging_sign": "Endicaor colganti de cajiga",
  "block.minecraft.oak_leaves": "Jueyas de cajiga",
  "block.minecraft.oak_log": "Tueru de cajiga",
  "block.minecraft.oak_planks": "Tablonis de cajiga",
  "block.minecraft.oak_pressure_plate": "Placa' prisión de cajiga",
  "block.minecraft.oak_sapling": "Armuellu de cajiga",
  "block.minecraft.oak_shelf": "Balda de cajiga",
  "block.minecraft.oak_sign": "Endicaor de cajiga",
  "block.minecraft.oak_slab": "Llosa de cajiga",
  "block.minecraft.oak_stairs": "Escaleras de cajiga",
  "block.minecraft.oak_trapdoor": "Puirtuca de cajiga",
  "block.minecraft.oak_wall_hanging_sign": "Endicaor colganti de cajiga'n pader",
  "block.minecraft.oak_wall_sign": "Endicaor de cajiga'n pader",
  "block.minecraft.oak_wood": "Maera de cajiga",
  "block.minecraft.observer": "Avilaor",
  "block.minecraft.obsidian": "Osidiana",
  "block.minecraft.ochre_froglight": "Ranaluz rubiu",
  "block.minecraft.ominous_banner": "Estandarti ominosu",
  "block.minecraft.open_eyeblossom": "Mirajlor abierta",
  "block.minecraft.orange_banner": "Estandarti naranja",
  "block.minecraft.orange_bed": "Cama naranja",
  "block.minecraft.orange_candle": "Vela naranja",
  "block.minecraft.orange_candle_cake": "Tarta con vela naranja",
  "block.minecraft.orange_carpet": "Alfombra naranja",
  "block.minecraft.orange_concrete": "Jormigón naranja",
  "block.minecraft.orange_concrete_powder": "Cementru naranja",
  "block.minecraft.orange_glazed_terracotta": "Azuleju naranja",
  "block.minecraft.orange_shulker_box": "Caja shulker naranja",
  "block.minecraft.orange_stained_glass": "Cristal tintáu de naranja",
  "block.minecraft.orange_stained_glass_pane": "Panel de cristal tintáu de naranja",
  "block.minecraft.orange_terracotta": "Terracota naranja",
  "block.minecraft.orange_tulip": "Tulipán naranja",
  "block.minecraft.orange_wool": "Lana naranja",
  "block.minecraft.oxeye_daisy": "Chivirita",
  "block.minecraft.oxidized_chiseled_copper": "Cobri cinceláu enruñicíu",
  "block.minecraft.oxidized_copper": "Cobri cinceláu",
  "block.minecraft.oxidized_copper_bars": "Barrotis de cobri enruñicíu",
  "block.minecraft.oxidized_copper_bulb": "Bumbillu de cobri enruñicíu",
  "block.minecraft.oxidized_copper_chain": "Caena de cobri enruñicíu",
  "block.minecraft.oxidized_copper_chest": "Baúl de cobri enruñicíu",
  "block.minecraft.oxidized_copper_door": "Puerta de cobri enruñicíu",
  "block.minecraft.oxidized_copper_golem_statue": "Estatua de gólem de cobri enruñicíu",
  "block.minecraft.oxidized_copper_grate": "Rijillu de cobri enruñicíu",
  "block.minecraft.oxidized_copper_lantern": "Farulucu de cobri enruñicíu",
  "block.minecraft.oxidized_copper_trapdoor": "Puirtuca de cobri enruñicíu",
  "block.minecraft.oxidized_cut_copper": "Cobri cortáu enruñicíu",
  "block.minecraft.oxidized_cut_copper_slab": "Llosa de cobri cortáu enruñicíu",
  "block.minecraft.oxidized_cut_copper_stairs": "Escalonis de cobri cortáu enruñicíu",
  "block.minecraft.oxidized_lightning_rod": "Pararrayos enruñicíu",
  "block.minecraft.packed_ice": "Helu compatu",
  "block.minecraft.packed_mud": "Barru compatu",
  "block.minecraft.pale_hanging_moss": "Mugu colganti esculuríu",
  "block.minecraft.pale_moss_block": "Bloqui de mugu esculuríu",
  "block.minecraft.pale_moss_carpet": "Alfombra de mugu esculuríu",
  "block.minecraft.pale_oak_button": "Butón de cajiga esculuríu",
  "block.minecraft.pale_oak_door": "Puerta de cajiga esculuríu",
  "block.minecraft.pale_oak_fence": "Cierru de cajiga esculuríu",
  "block.minecraft.pale_oak_fence_gate": "Purtillu de cajiga esculuríu",
  "block.minecraft.pale_oak_hanging_sign": "Endicaor colganti de cajiga esculuríu",
  "block.minecraft.pale_oak_leaves": "Jueyas de cajiga esculuríu",
  "block.minecraft.pale_oak_log": "Tueru de cajiga esculuríu",
  "block.minecraft.pale_oak_planks": "Tablonis de cajiga esculuríu",
  "block.minecraft.pale_oak_pressure_plate": "Placa' prisión de cajiga esculuríu",
  "block.minecraft.pale_oak_sapling": "Armuellu de cajiga esculuríu",
  "block.minecraft.pale_oak_shelf": "Balda de cajiga esculuríu",
  "block.minecraft.pale_oak_sign": "Endicaor de cajiga esculuríu",
  "block.minecraft.pale_oak_slab": "Llosa de cajiga esculuríu",
  "block.minecraft.pale_oak_stairs": "Escaleras de cajiga esculuríu",
  "block.minecraft.pale_oak_trapdoor": "Puirtuca de cajiga esculuríu",
  "block.minecraft.pale_oak_wall_hanging_sign": "Endicaor colganti de cajiga esculuríu'n pader",
  "block.minecraft.pale_oak_wall_sign": "Endicaor de cajiga esculuríu'n pader",
  "block.minecraft.pale_oak_wood": "Maera de cajiga esculuríu",
  "block.minecraft.pearlescent_froglight": "Ranaluz nacaráa",
  "block.minecraft.peony": "Poénia",
  "block.minecraft.petrified_oak_slab": "Llosa de cajiga petrificáa",
  "block.minecraft.piglin_head": "Zamosta de piglin",
  "block.minecraft.piglin_wall_head": "Zamosta de piglin en pader",
  "block.minecraft.pink_banner": "Estandarti rosa",
  "block.minecraft.pink_bed": "Cama rosa",
  "block.minecraft.pink_candle": "Vela rosa",
  "block.minecraft.pink_candle_cake": "Tarta con vela rosa",
  "block.minecraft.pink_carpet": "Alfombra rosa",
  "block.minecraft.pink_concrete": "Jormigón rosa",
  "block.minecraft.pink_concrete_powder": "Cementru rosa",
  "block.minecraft.pink_glazed_terracotta": "Azuleju rosa",
  "block.minecraft.pink_petals": "Pétalos rosas",
  "block.minecraft.pink_shulker_box": "Caja shulker rosa",
  "block.minecraft.pink_stained_glass": "Cristal tintáu de rosa",
  "block.minecraft.pink_stained_glass_pane": "Panel de cristal tintáu de rosa",
  "block.minecraft.pink_terracotta": "Terracota rosa",
  "block.minecraft.pink_tulip": "Tulipán rosa",
  "block.minecraft.pink_wool": "Lana rosa",
  "block.minecraft.piston": "Pistón",
  "block.minecraft.piston_head": "Cabezal de pistón",
  "block.minecraft.pitcher_crop": "Cultivu de planta d'odri",
  "block.minecraft.pitcher_plant": "Planta odri",
  "block.minecraft.player_head": "Zamosta de jubaor",
  "block.minecraft.player_head.named": "Zamosta de %s",
  "block.minecraft.player_wall_head": "Zamosta de jubaor en pader",
  "block.minecraft.podzol": "Podsol",
  "block.minecraft.pointed_dripstone": "Istalatita",
  "block.minecraft.polished_andesite": "Andisita pulíu",
  "block.minecraft.polished_andesite_slab": "Llosa d'andisita pulíu",
  "block.minecraft.polished_andesite_stairs": "Escalonis d'andisita pulíu",
  "block.minecraft.polished_basalt": "Basaltu pulíu",
  "block.minecraft.polished_blackstone": "Garma negru pulíu",
  "block.minecraft.polished_blackstone_brick_slab": "Llosa de ladrillu de garma negru pulíu",
  "block.minecraft.polished_blackstone_brick_stairs": "Escalonis de ladrillu de garma negru pulíu",
  "block.minecraft.polished_blackstone_brick_wall": "Moriu de ladrillu de garma negru pulíu",
  "block.minecraft.polished_blackstone_bricks": "Ladrillu de garma negru pulíu",
  "block.minecraft.polished_blackstone_button": "Butón de garma negru pulíu",
  "block.minecraft.polished_blackstone_pressure_plate": "Placa' presión de garma negru pulíu",
  "block.minecraft.polished_blackstone_slab": "Llosa de garma negru pulíu",
  "block.minecraft.polished_blackstone_stairs": "Escalonis de garma negru pulíu",
  "block.minecraft.polished_blackstone_wall": "Moriu de garma negru pulíu",
  "block.minecraft.polished_deepslate": "Pizarra pulíu",
  "block.minecraft.polished_deepslate_slab": "Llosa de pizarra pulíu",
  "block.minecraft.polished_deepslate_stairs": "Escalonis de pizarra pulíu",
  "block.minecraft.polished_deepslate_wall": "Moriu de pizarra pulíu",
  "block.minecraft.polished_diorite": "Diurita pulíu",
  "block.minecraft.polished_diorite_slab": "Llosa de diurita pulíu",
  "block.minecraft.polished_diorite_stairs": "Escalonis de diurita pulíu",
  "block.minecraft.polished_granite": "Granitu pulíu",
  "block.minecraft.polished_granite_slab": "Llosa de granitu pulíu",
  "block.minecraft.polished_granite_stairs": "Escalonis de granitu pulíu",
  "block.minecraft.polished_tuff": "Toba pulíu",
  "block.minecraft.polished_tuff_slab": "Llosa de toba pulíu",
  "block.minecraft.polished_tuff_stairs": "Escalonis de toba puíu",
  "block.minecraft.polished_tuff_wall": "Moriu de toba pulíu",
  "block.minecraft.poppy": "Mapola",
  "block.minecraft.potatoes": "Patatas",
  "block.minecraft.potted_acacia_sapling": "Tiestu con armuellu d'acaciu",
  "block.minecraft.potted_allium": "Tiestu con allium",
  "block.minecraft.potted_azalea_bush": "Tiestu con azalea",
  "block.minecraft.potted_azure_bluet": "Tiestu con bluet",
  "block.minecraft.potted_bamboo": "Tiestu con bambú",
  "block.minecraft.potted_birch_sapling": "Tiestu con armuellu d'abidul",
  "block.minecraft.potted_blue_orchid": "Tiestu con urquídea azul",
  "block.minecraft.potted_brown_mushroom": "Tiestu con jongu pardu",
  "block.minecraft.potted_cactus": "Tiestu con cactus",
  "block.minecraft.potted_cherry_sapling": "Tiestu con armuellu de cerezu",
  "block.minecraft.potted_closed_eyeblossom": "Tiestu con mirajlor cerráa",
  "block.minecraft.potted_cornflower": "Tiestu con acianu",
  "block.minecraft.potted_crimson_fungus": "Tiestu con jongu carmesín",
  "block.minecraft.potted_crimson_roots": "Tiestu con raicis carmesín",
  "block.minecraft.potted_dandelion": "Tiestu con dienti lión",
  "block.minecraft.potted_dark_oak_sapling": "Tiestu con armuellu de cajiga escuru",
  "block.minecraft.potted_dead_bush": "Tiestu con sietu ataláu",
  "block.minecraft.potted_fern": "Tiestu con jelechu",
  "block.minecraft.potted_flowering_azalea_bush": "Tiestu con azalea campizáu",
  "block.minecraft.potted_golden_dandelion": "Tiestu con churracamas doráu",
  "block.minecraft.potted_jungle_sapling": "Tiestu con armuellu de jungla",
  "block.minecraft.potted_lily_of_the_valley": "Tiestu con perlengue de valli",
  "block.minecraft.potted_mangrove_propagule": "Tiestu con brena de mangli",
  "block.minecraft.potted_oak_sapling": "Tiestu con armuellu de cajiga",
  "block.minecraft.potted_open_eyeblossom": "Tiestu con mirajlor abierta",
  "block.minecraft.potted_orange_tulip": "Tiestu con tulipán naranja",
  "block.minecraft.potted_oxeye_daisy": "Tiestu con chivirita",
  "block.minecraft.potted_pale_oak_sapling": "Tiestu con armuellu de cajiga esculuríu",
  "block.minecraft.potted_pink_tulip": "Tiestu con tulipán rosa",
  "block.minecraft.potted_poppy": "Tiestu con mapola",
  "block.minecraft.potted_red_mushroom": "Tiestu con jongu encarnáu",
  "block.minecraft.potted_red_tulip": "Tiestu con tulipán encarnáu",
  "block.minecraft.potted_spruce_sapling": "Tiestu con armuellu d'abetu",
  "block.minecraft.potted_torchflower": "Tiestu con prantaja",
  "block.minecraft.potted_warped_fungus": "Tiestu con jongu distorsionáu",
  "block.minecraft.potted_warped_roots": "Tiestu con raicis distorsionaas",
  "block.minecraft.potted_white_tulip": "Tiestu con tulipán brancu",
  "block.minecraft.potted_wither_rose": "Tiestu con rosa del Wither",
  "block.minecraft.powder_snow": "Ñevi en polvu",
  "block.minecraft.powder_snow_cauldron": "Tangarru con ñevi en polvu",
  "block.minecraft.powered_rail": "Raíl propulsor",
  "block.minecraft.prismarine": "Prismarina",
  "block.minecraft.prismarine_brick_slab": "Llosa de ladrillu de prismarina",
  "block.minecraft.prismarine_brick_stairs": "Escalonis de ladrillu de prismarina",
  "block.minecraft.prismarine_bricks": "Ladrillu de prismarina",
  "block.minecraft.prismarine_slab": "Llosa de prismarina",
  "block.minecraft.prismarine_stairs": "Escalonis de prismarina",
  "block.minecraft.prismarine_wall": "Moriu de prismarina",
  "block.minecraft.pumpkin": "Calabaza",
  "block.minecraft.pumpkin_stem": "Tayu de calabaza",
  "block.minecraft.purple_banner": "Estandarti moráu",
  "block.minecraft.purple_bed": "Cama moráa",
  "block.minecraft.purple_candle": "Vela moráa",
  "block.minecraft.purple_candle_cake": "Tarta con vela moráa",
  "block.minecraft.purple_carpet": "Alfombra moráa",
  "block.minecraft.purple_concrete": "Jormigón moráu",
  "block.minecraft.purple_concrete_powder": "Cementru moráu",
  "block.minecraft.purple_glazed_terracotta": "Azuleju moráu",
  "block.minecraft.purple_shulker_box": "Caja de shulker moráa",
  "block.minecraft.purple_stained_glass": "Cristal tintáu de moráu",
  "block.minecraft.purple_stained_glass_pane": "Panel de cristal tintáu de moráu",
  "block.minecraft.purple_terracotta": "Terracota moráa",
  "block.minecraft.purple_wool": "Lana moráu",
  "block.minecraft.purpur_block": "Bloqui de purpur",
  "block.minecraft.purpur_pillar": "Pilar de purpur",
  "block.minecraft.purpur_slab": "Llosa de purpur",
  "block.minecraft.purpur_stairs": "Escalonis de purpur",
  "block.minecraft.quartz_block": "Cuarzu",
  "block.minecraft.quartz_bricks": "Ladrillos de cuarzu",
  "block.minecraft.quartz_pillar": "Pilar de cuarzu",
  "block.minecraft.quartz_slab": "Llosa de cuarzu",
  "block.minecraft.quartz_stairs": "Escalonis de cuarzu",
  "block.minecraft.rail": "Raíl",
  "block.minecraft.raw_copper_block": "Bloqui de cobri brutu",
  "block.minecraft.raw_gold_block": "Bloqui d'oru brutu",
  "block.minecraft.raw_iron_block": "Bloqui de jierru brutu",
  "block.minecraft.red_banner": "Estandarti encarnáu",
  "block.minecraft.red_bed": "Cama encarnáa",
  "block.minecraft.red_candle": "Vela encarnáa",
  "block.minecraft.red_candle_cake": "Tarta con vela encarnáa",
  "block.minecraft.red_carpet": "Alfombra encarnáa",
  "block.minecraft.red_concrete": "Jormigón encarnáu",
  "block.minecraft.red_concrete_powder": "Cementru encarnáu",
  "block.minecraft.red_glazed_terracotta": "Azuleju encarnáu",
  "block.minecraft.red_mushroom": "Jongu encarnáu",
  "block.minecraft.red_mushroom_block": "Bloqui de jongu encarnáu",
  "block.minecraft.red_nether_brick_slab": "Llosa de ladrillu del Nether encarnáu",
  "block.minecraft.red_nether_brick_stairs": "Escalonis de ladrillu del Nether encarnáu",
  "block.minecraft.red_nether_brick_wall": "Moriu de ladrillu del Nether encarnáu",
  "block.minecraft.red_nether_bricks": "Ladrillu del Nether encarnáu",
  "block.minecraft.red_sand": "Arena encarnáu",
  "block.minecraft.red_sandstone": "Ariniza encarnáu",
  "block.minecraft.red_sandstone_slab": "Llosa d'ariniza encarnáu",
  "block.minecraft.red_sandstone_stairs": "Escalonis d'ariniza encarnáu",
  "block.minecraft.red_sandstone_wall": "Moriu d'ariniza encarnáu",
  "block.minecraft.red_shulker_box": "Caja de shulker encarnáa",
  "block.minecraft.red_stained_glass": "Cristal tintáu d'encarnáu",
  "block.minecraft.red_stained_glass_pane": "Panel de cristal tintáu d'encarnáu",
  "block.minecraft.red_terracotta": "Terracota encarnáa",
  "block.minecraft.red_tulip": "Tulipán encarnáu",
  "block.minecraft.red_wool": "Lana encarnáa",
  "block.minecraft.redstone_block": "Bloqui de redstone",
  "block.minecraft.redstone_lamp": "Lámpara de redstone",
  "block.minecraft.redstone_ore": "Mena de redstone",
  "block.minecraft.redstone_torch": "Aja de redstone",
  "block.minecraft.redstone_wall_torch": "Aja de redstone en pader",
  "block.minecraft.redstone_wire": "Cabli de redstone",
  "block.minecraft.reinforced_deepslate": "Pizarra rejorzáu",
  "block.minecraft.repeater": "Repetior de redstone",
  "block.minecraft.repeating_command_block": "Bloqui de comandu de repetición",
  "block.minecraft.resin_block": "Bloqui de risina",
  "block.minecraft.resin_brick_slab": "Llosa de ladrillu de risina",
  "block.minecraft.resin_brick_stairs": "Escalonis de ladrillu de risina",
  "block.minecraft.resin_brick_wall": "Moriu de ladrillu de risina",
  "block.minecraft.resin_bricks": "Ladrillu de risina",
  "block.minecraft.resin_clump": "Mazacoti de risina",
  "block.minecraft.respawn_anchor": "Nexu pa remanecer",
  "block.minecraft.rooted_dirt": "Tierra enraizáa",
  "block.minecraft.rose_bush": "Calambruju",
  "block.minecraft.sand": "Arena",
  "block.minecraft.sandstone": "Ariniza",
  "block.minecraft.sandstone_slab": "Llosa d'ariniza",
  "block.minecraft.sandstone_stairs": "Escalonis d'ariniza",
  "block.minecraft.sandstone_wall": "Moriu d'ariniza",
  "block.minecraft.scaffolding": "Andamiu",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Catalizaor de sculk",
  "block.minecraft.sculk_sensor": "Sensor de sculk",
  "block.minecraft.sculk_shrieker": "Chillaor de sculk",
  "block.minecraft.sculk_vein": "Vena de sculk",
  "block.minecraft.sea_lantern": "Linterna la mar",
  "block.minecraft.sea_pickle": "Pipinu de mar",
  "block.minecraft.seagrass": "Caloca baju",
  "block.minecraft.set_spawn": "Fijósi'l puntu pa remanecer",
  "block.minecraft.short_dry_grass": "Pación ataláu cortu",
  "block.minecraft.short_grass": "Herba cortu",
  "block.minecraft.shroomlight": "Brillongu",
  "block.minecraft.shulker_box": "Caja Shulker",
  "block.minecraft.skeleton_skull": "Crañu d'esqueletu",
  "block.minecraft.skeleton_wall_skull": "Crañu d'esqueletu",
  "block.minecraft.slime_block": "Bloqui de slime",
  "block.minecraft.small_amethyst_bud": "Gruñu d'amatista chicu",
  "block.minecraft.small_dripleaf": "Plantaforma chica",
  "block.minecraft.smithing_table": "Mesa de jirriría",
  "block.minecraft.smoker": "Ajumaor",
  "block.minecraft.smooth_basalt": "Basaltu lisu",
  "block.minecraft.smooth_quartz": "Bloqui de cuarzu lisu",
  "block.minecraft.smooth_quartz_slab": "Llosa de cuarzu lisu",
  "block.minecraft.smooth_quartz_stairs": "Escalonis de cuarzu lisu",
  "block.minecraft.smooth_red_sandstone": "Ariniza encarnáu lisu",
  "block.minecraft.smooth_red_sandstone_slab": "Llosa d'ariniza encarnáu lisu",
  "block.minecraft.smooth_red_sandstone_stairs": "Escalonis d'ariniza encarnáu lisu",
  "block.minecraft.smooth_sandstone": "Ariniza lisu",
  "block.minecraft.smooth_sandstone_slab": "Llosa d'ariniza lisu",
  "block.minecraft.smooth_sandstone_stairs": "Escalonis d'ariniza lisu",
  "block.minecraft.smooth_stone": "Garma lisu",
  "block.minecraft.smooth_stone_slab": "Llosa de garma lisu",
  "block.minecraft.sniffer_egg": "Güevu de sniffer",
  "block.minecraft.snow": "Capa de ñevi",
  "block.minecraft.snow_block": "Bloqui de ñevi",
  "block.minecraft.soul_campfire": "Lumbrera d'almas",
  "block.minecraft.soul_fire": "Lumbri d'almas",
  "block.minecraft.soul_lantern": "Farulillu d'almas",
  "block.minecraft.soul_sand": "Arena d'almas",
  "block.minecraft.soul_soil": "Tierra d'almas",
  "block.minecraft.soul_torch": "Aja d'almas",
  "block.minecraft.soul_wall_torch": "Aja d'almas en pader",
  "block.minecraft.spawn.not_valid": "Nu tienis cama u nexu pa remanecer cargáu, u puéin estar ustruíos",
  "block.minecraft.spawner": "Generaor de criaturas",
  "block.minecraft.spawner.desc1": "Interatúa con un güevu generaor:",
  "block.minecraft.spawner.desc2": "Estableci'l tipu de criatura",
  "block.minecraft.sponge": "Esponja",
  "block.minecraft.spore_blossom": "Jlor d'esporas",
  "block.minecraft.spruce_button": "Butón d'abetu",
  "block.minecraft.spruce_door": "Puerta d'abetu",
  "block.minecraft.spruce_fence": "Cierru d'abetu",
  "block.minecraft.spruce_fence_gate": "Purtillu d'abetu",
  "block.minecraft.spruce_hanging_sign": "Endicaor colganti d'abetu",
  "block.minecraft.spruce_leaves": "Jueyas d'abetu",
  "block.minecraft.spruce_log": "Tueru d'abetu",
  "block.minecraft.spruce_planks": "Tablonis d'abetu",
  "block.minecraft.spruce_pressure_plate": "Placa' prisión d'abetu",
  "block.minecraft.spruce_sapling": "Armuellu d'abetu",
  "block.minecraft.spruce_shelf": "Balda d'abetu",
  "block.minecraft.spruce_sign": "Endicaor d'abetu",
  "block.minecraft.spruce_slab": "Llosa d'abetu",
  "block.minecraft.spruce_stairs": "Escaleras d'abetu",
  "block.minecraft.spruce_trapdoor": "Puirtuca d'abetu",
  "block.minecraft.spruce_wall_hanging_sign": "Endicaor colganti d'abetu en pader",
  "block.minecraft.spruce_wall_sign": "Endicaor d'abetu en pader",
  "block.minecraft.spruce_wood": "Maera d'abetu",
  "block.minecraft.sticky_piston": "Pistón pegajosu",
  "block.minecraft.stone": "Garma",
  "block.minecraft.stone_brick_slab": "Llosa de ladrillu de garma",
  "block.minecraft.stone_brick_stairs": "Escalonis de ladrillu de garma",
  "block.minecraft.stone_brick_wall": "Moriu de ladrillu de garma",
  "block.minecraft.stone_bricks": "Ladrillu de garma",
  "block.minecraft.stone_button": "Butón de cantu",
  "block.minecraft.stone_pressure_plate": "Placa' prisión de cantu",
  "block.minecraft.stone_slab": "Llosa de garma",
  "block.minecraft.stone_stairs": "Escalonis de garma",
  "block.minecraft.stonecutter": "Cortacantos",
  "block.minecraft.stripped_acacia_log": "Tueru d'acaciu ensín corteza",
  "block.minecraft.stripped_acacia_wood": "Maera d'acaciu ensín corteza",
  "block.minecraft.stripped_bamboo_block": "Bloqui de bambú peláu",
  "block.minecraft.stripped_birch_log": "Tueru d'abidul ensín corteza",
  "block.minecraft.stripped_birch_wood": "Maera d'abidul ensín corteza",
  "block.minecraft.stripped_cherry_log": "Tueru de cerezu ensín corteza",
  "block.minecraft.stripped_cherry_wood": "Maera de cerezu ensín corteza",
  "block.minecraft.stripped_crimson_hyphae": "Hifas carmesín peláas",
  "block.minecraft.stripped_crimson_stem": "Tayu carmesín peláu",
  "block.minecraft.stripped_dark_oak_log": "Tueru de cajiga escuru ensín corteza",
  "block.minecraft.stripped_dark_oak_wood": "Maera de cajiga escuru ensin corteza",
  "block.minecraft.stripped_jungle_log": "Tueru de jungla ensín corteza",
  "block.minecraft.stripped_jungle_wood": "Maera de jungla ensín corteza",
  "block.minecraft.stripped_mangrove_log": "Tueru de mangli ensín corteza",
  "block.minecraft.stripped_mangrove_wood": "Maera de mangli ensín corteza",
  "block.minecraft.stripped_oak_log": "Tueru de cajiga ensín corteza",
  "block.minecraft.stripped_oak_wood": "Maera de cajiga ensín corteza",
  "block.minecraft.stripped_pale_oak_log": "Tueru de cajiga isculuría ensín corteza",
  "block.minecraft.stripped_pale_oak_wood": "Maera de cajiga isculuría ensín corteza",
  "block.minecraft.stripped_spruce_log": "Tueru d'abetu ensín corteza",
  "block.minecraft.stripped_spruce_wood": "Maera d'abetu ensín corteza",
  "block.minecraft.stripped_warped_hyphae": "Hifas distorsionaas pelaas",
  "block.minecraft.stripped_warped_stem": "Tayu distorsionáu peláu",
  "block.minecraft.structure_block": "Bloqui estrutural",
  "block.minecraft.structure_void": "Abizu estrutural",
  "block.minecraft.sugar_cane": "Caña d'azúcara",
  "block.minecraft.sunflower": "Girasol",
  "block.minecraft.suspicious_gravel": "Grija sospechosu",
  "block.minecraft.suspicious_sand": "Arena sospechosu",
  "block.minecraft.sweet_berry_bush": "Sietu de ráspanos dulcis",
  "block.minecraft.tall_dry_grass": "Pación ataláu altu",
  "block.minecraft.tall_grass": "Pación altu",
  "block.minecraft.tall_seagrass": "Caloca chicu altu",
  "block.minecraft.target": "Diana",
  "block.minecraft.terracotta": "Terracota",
  "block.minecraft.test_block": "Bloqui de pruebas",
  "block.minecraft.test_instance_block": "Bloqui de casu de prueba",
  "block.minecraft.tinted_glass": "Cristal opacu",
  "block.minecraft.tnt": "Dinamita",
  "block.minecraft.tnt.disabled": "Los ispañíos de dinamita están desativáos",
  "block.minecraft.torch": "Aja",
  "block.minecraft.torchflower": "Plantaja",
  "block.minecraft.torchflower_crop": "Cultivu de plantaja",
  "block.minecraft.trapped_chest": "Baúl trampa",
  "block.minecraft.trial_spawner": "Generaor de disafíu",
  "block.minecraft.tripwire": "Jilu trampa",
  "block.minecraft.tripwire_hook": "Ganchu de jilu",
  "block.minecraft.tube_coral": "Coral de tubu",
  "block.minecraft.tube_coral_block": "Bloqui de coral de tubu",
  "block.minecraft.tube_coral_fan": "Abanicu de tubu",
  "block.minecraft.tube_coral_wall_fan": "Abanicu de tubu en pader",
  "block.minecraft.tuff": "Toba",
  "block.minecraft.tuff_brick_slab": "Llosa de ladrillu de toba",
  "block.minecraft.tuff_brick_stairs": "Escalonis de ladrillu de toba",
  "block.minecraft.tuff_brick_wall": "Moriu de ladrillu de toba",
  "block.minecraft.tuff_bricks": "Ladrillu de toba",
  "block.minecraft.tuff_slab": "Llosa de toba",
  "block.minecraft.tuff_stairs": "Escalonis de toba",
  "block.minecraft.tuff_wall": "Moriu de toba",
  "block.minecraft.turtle_egg": "Güevu de turtúa",
  "block.minecraft.twisting_vines": "Enredaeras resturcías",
  "block.minecraft.twisting_vines_plant": "Planta d'enreaderas ritorcías",
  "block.minecraft.vault": "Arca",
  "block.minecraft.verdant_froglight": "Ranaluz verdi",
  "block.minecraft.vine": "Enreaderas",
  "block.minecraft.void_air": "Airi d'abizu",
  "block.minecraft.wall_torch": "Aja'n pader",
  "block.minecraft.warped_button": "Butón distorsionáu",
  "block.minecraft.warped_door": "Puerta distorsionáa",
  "block.minecraft.warped_fence": "Cierru distorsionáu",
  "block.minecraft.warped_fence_gate": "Purtillu distorsionáu",
  "block.minecraft.warped_fungus": "Jongu distorsionáu",
  "block.minecraft.warped_hanging_sign": "Endicaor colganti distorsionáu",
  "block.minecraft.warped_hyphae": "Hifas distorsionáas",
  "block.minecraft.warped_nylium": "Neceliu distorsionáu",
  "block.minecraft.warped_planks": "Tablonis distrosionaos",
  "block.minecraft.warped_pressure_plate": "Placa' prisión distorsionáa",
  "block.minecraft.warped_roots": "Raicis distorsionáas",
  "block.minecraft.warped_shelf": "Balda distorsionáa",
  "block.minecraft.warped_sign": "Endicaor distorsionáu",
  "block.minecraft.warped_slab": "Llosa distorsionáa",
  "block.minecraft.warped_stairs": "Escaleras distorsionáas",
  "block.minecraft.warped_stem": "Tayu distorsionáu",
  "block.minecraft.warped_trapdoor": "Puirtuca distorsionáa",
  "block.minecraft.warped_wall_hanging_sign": "Endicaor colganti distorsionáu'n pader",
  "block.minecraft.warped_wall_sign": "Endicaor distorsionáu'n pader",
  "block.minecraft.warped_wart_block": "Bloqui de virrugas distorsionáas",
  "block.minecraft.water": "Augua",
  "block.minecraft.water_cauldron": "Tangarru con augua",
  "block.minecraft.waxed_chiseled_copper": "Cobri cinceláu enceráu",
  "block.minecraft.waxed_copper_bars": "Barrotis de cobri enceráu",
  "block.minecraft.waxed_copper_block": "Bloqui de cobri enceráu",
  "block.minecraft.waxed_copper_bulb": "Bumbillu de cobri enceráu",
  "block.minecraft.waxed_copper_chain": "Caena de cobri enceráu",
  "block.minecraft.waxed_copper_chest": "Baúl de cobri enceráu",
  "block.minecraft.waxed_copper_door": "Puerta de cobri enceráu",
  "block.minecraft.waxed_copper_golem_statue": "Estatua de gólem de cobri enceráu",
  "block.minecraft.waxed_copper_grate": "Rijillu de cobri enceráu",
  "block.minecraft.waxed_copper_lantern": "Farulucu de cobri enceráu",
  "block.minecraft.waxed_copper_trapdoor": "Puirtuca de cobri enceráu",
  "block.minecraft.waxed_cut_copper": "Cobri cortáu enceráu",
  "block.minecraft.waxed_cut_copper_slab": "Llosa de cobri cortáu enceráu",
  "block.minecraft.waxed_cut_copper_stairs": "Escalonis de cobri cortáu enceráu",
  "block.minecraft.waxed_exposed_chiseled_copper": "Cobri cinceláu ispuestu enceráu",
  "block.minecraft.waxed_exposed_copper": "Cobri ispuestu enceráu",
  "block.minecraft.waxed_exposed_copper_bars": "Barrotis de cobri espuestu enceráu",
  "block.minecraft.waxed_exposed_copper_bulb": "Bumbillu de cobri ispuestu enceráu",
  "block.minecraft.waxed_exposed_copper_chain": "Caena de cobri espuestu enceráu",
  "block.minecraft.waxed_exposed_copper_chest": "Baúl de cobri espuestu enceráu",
  "block.minecraft.waxed_exposed_copper_door": "Puerta de cobri ispuestu enceráu",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Estatua de gólem de cobri espuestu enceráu",
  "block.minecraft.waxed_exposed_copper_grate": "Rijillu de cobri ispuestu enceráu",
  "block.minecraft.waxed_exposed_copper_lantern": "Farulucu de cobri espuestu enceráu",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Puirtuca de cobri ispuestu enceráu",
  "block.minecraft.waxed_exposed_cut_copper": "Cobri cortáu ispuestu enceráu",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Llosa de cobri cortáu ispuestu enceráu",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Escalonis de cobri cortáu ispuestu enceráu",
  "block.minecraft.waxed_exposed_lightning_rod": "Pararrayos espuestu enceráu",
  "block.minecraft.waxed_lightning_rod": "Pararrayos enceráu",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Cobri cinceláu enruñicíu enceráu",
  "block.minecraft.waxed_oxidized_copper": "Cobri enruñicíu enceráu",
  "block.minecraft.waxed_oxidized_copper_bars": "Barrotis de cobri enruñicíu enceráu",
  "block.minecraft.waxed_oxidized_copper_bulb": "Bumbillu de cobri enruñicíu enceráu",
  "block.minecraft.waxed_oxidized_copper_chain": "Caena de cobri enruñicíu enceráu",
  "block.minecraft.waxed_oxidized_copper_chest": "Baúl de cobri enruñicíu enceráu",
  "block.minecraft.waxed_oxidized_copper_door": "Puerta de cobri oxidáu enceráu",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Estatua de gólem de cobri enruñicíu enceráu",
  "block.minecraft.waxed_oxidized_copper_grate": "Rijillu de cobri osidáu enceráu",
  "block.minecraft.waxed_oxidized_copper_lantern": "Farulucu de cobri enruñicíu enceráu",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Puirtuca de cobri enruñicíu enceráu",
  "block.minecraft.waxed_oxidized_cut_copper": "Cobri cortáu enruñicíu enceráu",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Llosa de cobri cortáu enruñicíu enceráu",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Escalonis de cobri cortáu enruñicíu enceráu",
  "block.minecraft.waxed_oxidized_lightning_rod": "Pararrayos enruñicíu enceráu",
  "block.minecraft.waxed_weathered_chiseled_copper": "Cobri cinceláu envijicíu enceráu",
  "block.minecraft.waxed_weathered_copper": "Cobri degradáu enceráu",
  "block.minecraft.waxed_weathered_copper_bars": "Barrotis de cobri envijicíu enceráu",
  "block.minecraft.waxed_weathered_copper_bulb": "Bumbillu de cobri envijicíu enceráu",
  "block.minecraft.waxed_weathered_copper_chain": "Cadena de cobre envijicíu enceráu",
  "block.minecraft.waxed_weathered_copper_chest": "Baúl de cobri envijicíu enceráu",
  "block.minecraft.waxed_weathered_copper_door": "Puerta de cobri invijicíu enceráu",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Estatua de gólem de cobri envijicíu enceráu",
  "block.minecraft.waxed_weathered_copper_grate": "Rijillu de cobri ivijicíu enceráu",
  "block.minecraft.waxed_weathered_copper_lantern": "Farulucu de cobri envijicíu enceráu",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Puirtuca de cobri invijicíu enceráu",
  "block.minecraft.waxed_weathered_cut_copper": "Cobri cortáu invijicíu enceráu",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Llosa de cobri cortáu invijicíu enceráu",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Escalonis de cobri cortáu invijicíu enceráu",
  "block.minecraft.waxed_weathered_lightning_rod": "Pararrayos envijicíu enceráu",
  "block.minecraft.weathered_chiseled_copper": "Cobri cinceláu invijicíu",
  "block.minecraft.weathered_copper": "Cobri invijicíu",
  "block.minecraft.weathered_copper_bars": "Barrotis de cobri envijicíu",
  "block.minecraft.weathered_copper_bulb": "Bumbillu de cobri invijicíu",
  "block.minecraft.weathered_copper_chain": "Caena de cobri envijicíu",
  "block.minecraft.weathered_copper_chest": "Baúl de cobri envijicíu",
  "block.minecraft.weathered_copper_door": "Puerta de cobri invijicíu",
  "block.minecraft.weathered_copper_golem_statue": "Estatua de gólem de cobri envijicíu",
  "block.minecraft.weathered_copper_grate": "Rijillu de cobri invijicíu",
  "block.minecraft.weathered_copper_lantern": "Farulucu de cobri envijicíu",
  "block.minecraft.weathered_copper_trapdoor": "Puirtuca de cobri invijicíu",
  "block.minecraft.weathered_cut_copper": "Cobri cortáu invijicíu",
  "block.minecraft.weathered_cut_copper_slab": "Llosa de cobri cortáu invijicíu",
  "block.minecraft.weathered_cut_copper_stairs": "Escalonis de cobri cortáu invijicíu",
  "block.minecraft.weathered_lightning_rod": "Pararrayos envijicíu",
  "block.minecraft.weeping_vines": "Enreaderas murinosas",
  "block.minecraft.weeping_vines_plant": "Planta d'enredaeras llorosas",
  "block.minecraft.wet_sponge": "Esponja mojáa",
  "block.minecraft.wheat": "Cultivu de trigu",
  "block.minecraft.white_banner": "Estandarti brancu",
  "block.minecraft.white_bed": "Cama branca",
  "block.minecraft.white_candle": "Vela branca",
  "block.minecraft.white_candle_cake": "Tarta con vela branca",
  "block.minecraft.white_carpet": "Alfombra branca",
  "block.minecraft.white_concrete": "Jormigón brancu",
  "block.minecraft.white_concrete_powder": "Cementru brancu",
  "block.minecraft.white_glazed_terracotta": "Azuleju brancu",
  "block.minecraft.white_shulker_box": "Caja de shulker brancu",
  "block.minecraft.white_stained_glass": "Cristal tintáu de brancu",
  "block.minecraft.white_stained_glass_pane": "Panel de cristal tintáu de brancu",
  "block.minecraft.white_terracotta": "Terracota brancu",
  "block.minecraft.white_tulip": "Tulipán brancu",
  "block.minecraft.white_wool": "Lana brancu",
  "block.minecraft.wildflowers": "Jluricillas silvestris",
  "block.minecraft.wither_rose": "Rosa del Wither",
  "block.minecraft.wither_skeleton_skull": "Crañu d'esqueletu del Wither",
  "block.minecraft.wither_skeleton_wall_skull": "Crañu d'esqueletu del Wither en pader",
  "block.minecraft.yellow_banner": "Estandarti amarillu",
  "block.minecraft.yellow_bed": "Cama amarilla",
  "block.minecraft.yellow_candle": "Vela amarilla",
  "block.minecraft.yellow_candle_cake": "Tarta con vela amarilla",
  "block.minecraft.yellow_carpet": "Alfombra amarilla",
  "block.minecraft.yellow_concrete": "Jormigón amarillu",
  "block.minecraft.yellow_concrete_powder": "Cementru amarillu",
  "block.minecraft.yellow_glazed_terracotta": "Azuleju amarillu",
  "block.minecraft.yellow_shulker_box": "Caja de shulker amarilla",
  "block.minecraft.yellow_stained_glass": "Cristal tintáu de amarillu",
  "block.minecraft.yellow_stained_glass_pane": "Panel de cristal tintáu de amarillu",
  "block.minecraft.yellow_terracotta": "Terracota amarillu",
  "block.minecraft.yellow_wool": "Lana amarillu",
  "block.minecraft.zombie_head": "Zamosta de zombi",
  "block.minecraft.zombie_wall_head": "Zamosta de zombi",
  "item.minecraft.acacia_boat": "Barcu d'acaciu",
  "item.minecraft.acacia_chest_boat": "Barcu d'acaciu con baúl",
  "item.minecraft.allay_spawn_egg": "Güevu generaor d'allay",
  "item.minecraft.amethyst_shard": "Framentu d'amatista",
  "item.minecraft.angler_pottery_shard": "Cachu de barru de caña' pescar",
  "item.minecraft.angler_pottery_sherd": "Cachu de barru de caña' pescar",
  "item.minecraft.apple": "Manzana",
  "item.minecraft.archer_pottery_shard": "Cachu de barru d'arcu",
  "item.minecraft.archer_pottery_sherd": "Cachu de barru d'arcu",
  "item.minecraft.armadillo_scute": "Escata d'armaíllu",
  "item.minecraft.armadillo_spawn_egg": "Güevu generaor d'armaíllu",
  "item.minecraft.armor_stand": "Cosu' las armaúras",
  "item.minecraft.arms_up_pottery_shard": "Cachu de barru de monigoti",
  "item.minecraft.arms_up_pottery_sherd": "Cachu de barru de monigoti",
  "item.minecraft.arrow": "Flecha",
  "item.minecraft.axolotl_bucket": "Tangarru con ajoloti",
  "item.minecraft.axolotl_spawn_egg": "Güevu generaor d'ajoloti",
  "item.minecraft.baked_potato": "Patata amurriagáa",
  "item.minecraft.bamboo_chest_raft": "Balsa de bambú con baúl",
  "item.minecraft.bamboo_raft": "Balsa de bambú",
  "item.minecraft.bat_spawn_egg": "Güevu generaor de sapulatu",
  "item.minecraft.bee_spawn_egg": "Güevu generaor d'abeja",
  "item.minecraft.beef": "Fileti crudu",
  "item.minecraft.beetroot": "Remolacha",
  "item.minecraft.beetroot_seeds": "Simienti de remolacha",
  "item.minecraft.beetroot_soup": "Cucíu de remolacha",
  "item.minecraft.birch_boat": "Barcu d'abidul",
  "item.minecraft.birch_chest_boat": "Barcu d'abidul con baúl",
  "item.minecraft.black_bundle": "Sacu negru",
  "item.minecraft.black_dye": "Tinti negru",
  "item.minecraft.black_harness": "Arnés negru",
  "item.minecraft.blade_pottery_shard": "Cachu de barru d'espada",
  "item.minecraft.blade_pottery_sherd": "Cachu de barru d'espada",
  "item.minecraft.blaze_powder": "Polvu de blaze",
  "item.minecraft.blaze_rod": "Caña de blaze",
  "item.minecraft.blaze_spawn_egg": "Güevu generaor de blaze",
  "item.minecraft.blue_bundle": "Sacu azul",
  "item.minecraft.blue_dye": "Tinti azul",
  "item.minecraft.blue_egg": "Güevu azul",
  "item.minecraft.blue_harness": "Arnés azul",
  "item.minecraft.bogged_spawn_egg": "Güevu generaor de ciénagu",
  "item.minecraft.bolt_armor_trim_smithing_template": "Moldi de jirrería",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Diseñu d'armaúra de remachis",
  "item.minecraft.bone": "Güesu",
  "item.minecraft.bone_meal": "Polvu de güesu",
  "item.minecraft.book": "Libru",
  "item.minecraft.bordure_indented_banner_pattern": "Estampáu de burdura dentáa",
  "item.minecraft.bow": "Arcu",
  "item.minecraft.bowl": "Cuencu",
  "item.minecraft.bread": "Pan",
  "item.minecraft.breeze_rod": "Caña de breeze",
  "item.minecraft.breeze_spawn_egg": "Güevu generaor de breeze",
  "item.minecraft.brewer_pottery_shard": "Cachu de barru de brebaju",
  "item.minecraft.brewer_pottery_sherd": "Cachu de barru de brebaju",
  "item.minecraft.brewing_stand": "Soporti pa berbajos",
  "item.minecraft.brick": "Ladrillu",
  "item.minecraft.brown_bundle": "Sacu pardu",
  "item.minecraft.brown_dye": "Tinti pardu",
  "item.minecraft.brown_egg": "Güevu pardu",
  "item.minecraft.brown_harness": "Arnés pardu",
  "item.minecraft.brush": "Cipíu",
  "item.minecraft.bucket": "Calderu",
  "item.minecraft.bundle": "Sacu",
  "item.minecraft.bundle.empty": "Abizu",
  "item.minecraft.bundle.empty.description": "Puéi contener una pila ojetos mistos",
  "item.minecraft.bundle.full": "Combláu",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Cachu de barru de lumbri",
  "item.minecraft.burn_pottery_sherd": "Cachu de barru de lumbri",
  "item.minecraft.camel_husk_spawn_egg": "Güevu generaor de camellu disecáu",
  "item.minecraft.camel_spawn_egg": "Güevu generaor de camellu",
  "item.minecraft.carrot": "Acenoria",
  "item.minecraft.carrot_on_a_stick": "Caña con acenoria",
  "item.minecraft.cat_spawn_egg": "Güevu generaor de gatu",
  "item.minecraft.cauldron": "Tangarru",
  "item.minecraft.cave_spider_spawn_egg": "Güevu generaor d'araña de sopláu",
  "item.minecraft.chainmail_boots": "Botas de cota de malla",
  "item.minecraft.chainmail_chestplate": "Petu de cota de malla",
  "item.minecraft.chainmail_helmet": "Cascu de cota de malla",
  "item.minecraft.chainmail_leggings": "Pantalonis de cota de malla",
  "item.minecraft.charcoal": "Carbón vegetal",
  "item.minecraft.cherry_boat": "Barcu de cerezu",
  "item.minecraft.cherry_chest_boat": "Barcu de cerezu con baúl",
  "item.minecraft.chest_minecart": "Vagoneta con baúl",
  "item.minecraft.chicken": "Pollu crudu",
  "item.minecraft.chicken_spawn_egg": "Güevu generaor de picasuelos",
  "item.minecraft.chorus_fruit": "Fruta coral",
  "item.minecraft.clay_ball": "Bola d'arcilla",
  "item.minecraft.clock": "Reló",
  "item.minecraft.coal": "Carbón",
  "item.minecraft.coast_armor_trim_smithing_template": "Moldi de jirrería",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Diseñu d'armaúra costera",
  "item.minecraft.cocoa_beans": "Simienti de cacau",
  "item.minecraft.cod": "Bacalau crudu",
  "item.minecraft.cod_bucket": "Calderu con bacalau",
  "item.minecraft.cod_spawn_egg": "Güevu generaor de bacalau",
  "item.minecraft.command_block_minecart": "Vagoneta con bloqui de comandos",
  "item.minecraft.compass": "Brújula",
  "item.minecraft.cooked_beef": "Fileti asáu",
  "item.minecraft.cooked_chicken": "Pollu asáu",
  "item.minecraft.cooked_cod": "Bacallu amurriagáu",
  "item.minecraft.cooked_mutton": "Corderu asáu",
  "item.minecraft.cooked_porkchop": "Chumarru asáu",
  "item.minecraft.cooked_rabbit": "Lapín asáu",
  "item.minecraft.cooked_salmon": "Salmón ajumáu",
  "item.minecraft.cookie": "Galleta",
  "item.minecraft.copper_axe": "Jacha de cobri",
  "item.minecraft.copper_boots": "Botas de cobri",
  "item.minecraft.copper_chestplate": "Petu de cobri",
  "item.minecraft.copper_golem_spawn_egg": "Güevu generaor de gólem de cobri",
  "item.minecraft.copper_helmet": "Cascu de cobri",
  "item.minecraft.copper_hoe": "Cesoria de cobri",
  "item.minecraft.copper_horse_armor": "Armaúra de cobri pa caballu",
  "item.minecraft.copper_ingot": "Lingoti de cobri",
  "item.minecraft.copper_leggings": "Pantalonis de cobri",
  "item.minecraft.copper_nautilus_armor": "Armaúra de cobri pa nautilu",
  "item.minecraft.copper_nugget": "Pibita de cobri",
  "item.minecraft.copper_pickaxe": "Picu de cobri",
  "item.minecraft.copper_shovel": "Tul de cobri",
  "item.minecraft.copper_spear": "Lanza de cobri",
  "item.minecraft.copper_sword": "Espada de cobri",
  "item.minecraft.cow_spawn_egg": "Güevu generaor de vaca",
  "item.minecraft.creaking_spawn_egg": "Güevu generaor de crepitanti",
  "item.minecraft.creeper_banner_pattern": "Diseñu d'estandarti",
  "item.minecraft.creeper_banner_pattern.desc": "Estampáu de creeper",
  "item.minecraft.creeper_banner_pattern.new": "Estampáu de creeper",
  "item.minecraft.creeper_spawn_egg": "Güevu generaor de creeper",
  "item.minecraft.crossbow": "Ballesta",
  "item.minecraft.crossbow.projectile": "Pruyitil:",
  "item.minecraft.crossbow.projectile.multiple": "Pruyitil: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Pruyitil: %s",
  "item.minecraft.cyan_bundle": "Sacu cian",
  "item.minecraft.cyan_dye": "Tinti cian",
  "item.minecraft.cyan_harness": "Arnés cian",
  "item.minecraft.danger_pottery_shard": "Cachu de barru de piligru",
  "item.minecraft.danger_pottery_sherd": "Cachu de barru de piligru",
  "item.minecraft.dark_oak_boat": "Barcu de cajiga escuru",
  "item.minecraft.dark_oak_chest_boat": "Barcu de cajiga escuru con baúl",
  "item.minecraft.debug_stick": "Palu Debug",
  "item.minecraft.debug_stick.empty": "%s nu tien propiedáis",
  "item.minecraft.debug_stick.select": "selecionósi «%s» (%s)",
  "item.minecraft.debug_stick.update": "«%s» a %s",
  "item.minecraft.diamond": "Diamanti",
  "item.minecraft.diamond_axe": "Jacha de diamanti",
  "item.minecraft.diamond_boots": "Botas de diamanti",
  "item.minecraft.diamond_chestplate": "Petu de diamanti",
  "item.minecraft.diamond_helmet": "Cascu de diamanti",
  "item.minecraft.diamond_hoe": "Cesoria de diamanti",
  "item.minecraft.diamond_horse_armor": "Armaúra de caballu de diamanti",
  "item.minecraft.diamond_leggings": "Pantalonis de diamanti",
  "item.minecraft.diamond_nautilus_armor": "Armaúra de diamanti pa nautilu",
  "item.minecraft.diamond_pickaxe": "Picu de diamanti",
  "item.minecraft.diamond_shovel": "Tul de diamanti",
  "item.minecraft.diamond_spear": "Lanza de diamanti",
  "item.minecraft.diamond_sword": "Espada de diamanti",
  "item.minecraft.disc_fragment_5": "Framentu de discu",
  "item.minecraft.disc_fragment_5.desc": "Discu de música - 5",
  "item.minecraft.dolphin_spawn_egg": "Güevu generaor de dujinu",
  "item.minecraft.donkey_spawn_egg": "Güevu generaor de burru",
  "item.minecraft.dragon_breath": "Alientu de dragón",
  "item.minecraft.dried_kelp": "Caloca ataláu",
  "item.minecraft.drowned_spawn_egg": "Güevu generaor d'ajogáu",
  "item.minecraft.dune_armor_trim_smithing_template": "Moldi de jirrería",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Diseñu d'armaúra de las dunas",
  "item.minecraft.echo_shard": "Fragmentu resonanti",
  "item.minecraft.egg": "Güevu",
  "item.minecraft.elder_guardian_spawn_egg": "Güevu generaor de guardián vieju",
  "item.minecraft.elytra": "Élitros",
  "item.minecraft.emerald": "Esmeralda",
  "item.minecraft.enchanted_book": "Libru maldáu",
  "item.minecraft.enchanted_golden_apple": "Manzana doráa encantáa",
  "item.minecraft.end_crystal": "Cristal del End",
  "item.minecraft.ender_dragon_spawn_egg": "Güevu generaor d'Enderdragón",
  "item.minecraft.ender_eye": "Lámparu d'ender",
  "item.minecraft.ender_pearl": "Perla d'ender",
  "item.minecraft.enderman_spawn_egg": "Güevu generaor d'Enderman",
  "item.minecraft.endermite_spawn_egg": "Güevu generaor d'Endermite",
  "item.minecraft.evoker_spawn_egg": "Güevu generaor d'evocaor",
  "item.minecraft.experience_bottle": "Frascu d'ispiriencia",
  "item.minecraft.explorer_pottery_shard": "Cachu de barru de mapa",
  "item.minecraft.explorer_pottery_sherd": "Cachu de barru de mapa",
  "item.minecraft.eye_armor_trim_smithing_template": "Moldi de jirrería",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Diseñu d'armaúra d'ojos",
  "item.minecraft.feather": "Pluma",
  "item.minecraft.fermented_spider_eye": "Lámparu d'araña fermentáu",
  "item.minecraft.field_masoned_banner_pattern": "Estampáu de mazonáu",
  "item.minecraft.filled_map": "Mapa",
  "item.minecraft.fire_charge": "Carga ígnea",
  "item.minecraft.firework_rocket": "Cobeti de fueos artificialis",
  "item.minecraft.firework_rocket.flight": "Duración del vuelu:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Estrella de fueos artificialis",
  "item.minecraft.firework_star.black": "Negru",
  "item.minecraft.firework_star.blue": "Azul",
  "item.minecraft.firework_star.brown": "Pardu",
  "item.minecraft.firework_star.custom_color": "Personalizáu",
  "item.minecraft.firework_star.cyan": "Cian",
  "item.minecraft.firework_star.fade_to": "Güélvise",
  "item.minecraft.firework_star.flicker": "Centelléu",
  "item.minecraft.firework_star.gray": "Pedrés",
  "item.minecraft.firework_star.green": "Verdi",
  "item.minecraft.firework_star.light_blue": "Azul claru",
  "item.minecraft.firework_star.light_gray": "Pedrés claru",
  "item.minecraft.firework_star.lime": "Lima",
  "item.minecraft.firework_star.magenta": "Magenta",
  "item.minecraft.firework_star.orange": "Naranja",
  "item.minecraft.firework_star.pink": "Rosa",
  "item.minecraft.firework_star.purple": "Moráu",
  "item.minecraft.firework_star.red": "Encarnáu",
  "item.minecraft.firework_star.shape": "Jorma iscunucía",
  "item.minecraft.firework_star.shape.burst": "Ispañíu",
  "item.minecraft.firework_star.shape.creeper": "Con forma de creeper",
  "item.minecraft.firework_star.shape.large_ball": "Bola grandi",
  "item.minecraft.firework_star.shape.small_ball": "Bola chica",
  "item.minecraft.firework_star.shape.star": "Con jorma d'estrella",
  "item.minecraft.firework_star.trail": "Rastru",
  "item.minecraft.firework_star.white": "Brancu",
  "item.minecraft.firework_star.yellow": "Amarillu",
  "item.minecraft.fishing_rod": "Caña' pescar",
  "item.minecraft.flint": "Pedernal",
  "item.minecraft.flint_and_steel": "Chisqueru",
  "item.minecraft.flow_armor_trim_smithing_template": "Moldi de jirrería",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Diseñu d'armaúra d'espiral",
  "item.minecraft.flow_banner_pattern": "Diseñu d'estandarti",
  "item.minecraft.flow_banner_pattern.desc": "Estampáu d'espiral",
  "item.minecraft.flow_banner_pattern.new": "Estampáu d'espiral",
  "item.minecraft.flow_pottery_sherd": "Cachu de barru de lobu",
  "item.minecraft.flower_banner_pattern": "Diseñu d'estandarti",
  "item.minecraft.flower_banner_pattern.desc": "Estampáu de jlor",
  "item.minecraft.flower_banner_pattern.new": "Estampáu de jlor",
  "item.minecraft.flower_pot": "Tiestu",
  "item.minecraft.fox_spawn_egg": "Güevu generaor de rasposu",
  "item.minecraft.friend_pottery_shard": "Cachu de barru d'amistá",
  "item.minecraft.friend_pottery_sherd": "Cachu de barru d'amistá",
  "item.minecraft.frog_spawn_egg": "Güevu generaor de salonquia",
  "item.minecraft.furnace_minecart": "Vagoneta con jornu",
  "item.minecraft.ghast_spawn_egg": "Güevu generaor de ghast",
  "item.minecraft.ghast_tear": "Glágrima de ghast",
  "item.minecraft.glass_bottle": "Frascu de cristal",
  "item.minecraft.glistering_melon_slice": "Rodaja de sandía estelanti",
  "item.minecraft.globe_banner_pattern": "Diseñu d'estandarti de planeta",
  "item.minecraft.globe_banner_pattern.desc": "Estampáu de planeta",
  "item.minecraft.globe_banner_pattern.new": "Estampáu de planeta",
  "item.minecraft.glow_berries": "Ráspanos estelantis",
  "item.minecraft.glow_ink_sac": "Sacu de tinta estelanti",
  "item.minecraft.glow_item_frame": "Marcu estelanti",
  "item.minecraft.glow_squid_spawn_egg": "Güevu generaor de maganu estelanti",
  "item.minecraft.glowstone_dust": "Polvu de garma estelanti",
  "item.minecraft.goat_horn": "Cuernu de cabra",
  "item.minecraft.goat_spawn_egg": "Güevu generaor de cabra",
  "item.minecraft.gold_ingot": "Lingoti d'oru",
  "item.minecraft.gold_nugget": "Pibita d'oru",
  "item.minecraft.golden_apple": "Manzana doráa",
  "item.minecraft.golden_axe": "Jacha d'oru",
  "item.minecraft.golden_boots": "Botas d'oru",
  "item.minecraft.golden_carrot": "Acenoria doráa",
  "item.minecraft.golden_chestplate": "Petu d'oru",
  "item.minecraft.golden_helmet": "Cascu d'oru",
  "item.minecraft.golden_hoe": "Cesoria d'oru",
  "item.minecraft.golden_horse_armor": "Armaúra de caballu d'oru",
  "item.minecraft.golden_leggings": "Pantalonis d'oru",
  "item.minecraft.golden_nautilus_armor": "Armaúra d'oru pa nautilu",
  "item.minecraft.golden_pickaxe": "Picu d'oru",
  "item.minecraft.golden_shovel": "Tul d'oru",
  "item.minecraft.golden_spear": "Lanza d'oru",
  "item.minecraft.golden_sword": "Espada d'oru",
  "item.minecraft.gray_bundle": "Sacu pedrés",
  "item.minecraft.gray_dye": "Tinti pedrés",
  "item.minecraft.gray_harness": "Arnés pedrés",
  "item.minecraft.green_bundle": "Sacu verdi",
  "item.minecraft.green_dye": "Tinti verdi",
  "item.minecraft.green_harness": "Arnés verdi",
  "item.minecraft.guardian_spawn_egg": "Güevu generaor de guardián",
  "item.minecraft.gunpowder": "Pólvora",
  "item.minecraft.guster_banner_pattern": "Diseñu d'estandarti",
  "item.minecraft.guster_banner_pattern.desc": "Estampáu de breeze",
  "item.minecraft.guster_banner_pattern.new": "Estampáu de breeze",
  "item.minecraft.guster_pottery_sherd": "Cachu de barru de breeze",
  "item.minecraft.happy_ghast_spawn_egg": "Güevu generaor de ghast filiz",
  "item.minecraft.harness": "Arnés",
  "item.minecraft.heart_of_the_sea": "Corazón de la mar",
  "item.minecraft.heart_pottery_shard": "Cachu de barru de corazón",
  "item.minecraft.heart_pottery_sherd": "Cachu de barru de corazón",
  "item.minecraft.heartbreak_pottery_shard": "Cachu de barru de corazón rotu",
  "item.minecraft.heartbreak_pottery_sherd": "Cachu de barru de corazón rotu",
  "item.minecraft.hoglin_spawn_egg": "Güevu generaor d'hoglin",
  "item.minecraft.honey_bottle": "Frascu con miel",
  "item.minecraft.honeycomb": "Panal",
  "item.minecraft.hopper_minecart": "Vagoneta con tolva",
  "item.minecraft.horse_spawn_egg": "Güevu generaor de caballu",
  "item.minecraft.host_armor_trim_smithing_template": "Moldi de jirriría",
  "item.minecraft.host_armor_trim_smithing_template.new": "Diseñu d'armaúra d'anfitrión",
  "item.minecraft.howl_pottery_shard": "Cachu de barru d'aullíu",
  "item.minecraft.howl_pottery_sherd": "Cachu de barru d'aullíu",
  "item.minecraft.husk_spawn_egg": "Güevu generaor de momia",
  "item.minecraft.ink_sac": "Sacu de tinta",
  "item.minecraft.iron_axe": "Jacha de jierru",
  "item.minecraft.iron_boots": "Botas de jierru",
  "item.minecraft.iron_chestplate": "Petu de jierru",
  "item.minecraft.iron_golem_spawn_egg": "Güevu generaor de gólem de jierru",
  "item.minecraft.iron_helmet": "Cascu de jierru",
  "item.minecraft.iron_hoe": "Cesoria de jierru",
  "item.minecraft.iron_horse_armor": "Armaúra de caballu de jierru",
  "item.minecraft.iron_ingot": "Lingoti de jierru",
  "item.minecraft.iron_leggings": "Pantalonis de jierru",
  "item.minecraft.iron_nautilus_armor": "Armaúra de jierru pa nautilu",
  "item.minecraft.iron_nugget": "Pibita de jierru",
  "item.minecraft.iron_pickaxe": "Picu de jierru",
  "item.minecraft.iron_shovel": "Tul de jierru",
  "item.minecraft.iron_spear": "Lanza de jierru",
  "item.minecraft.iron_sword": "Espada de jierru",
  "item.minecraft.item_frame": "Marcu",
  "item.minecraft.jungle_boat": "Barcu de jungla",
  "item.minecraft.jungle_chest_boat": "Barcu de jungla con baúl",
  "item.minecraft.knowledge_book": "Enciclopedia",
  "item.minecraft.lapis_lazuli": "Lapislázuli",
  "item.minecraft.lava_bucket": "Calderu con lava",
  "item.minecraft.lead": "Jaretu",
  "item.minecraft.leather": "Cueru",
  "item.minecraft.leather_boots": "Botas de cueru",
  "item.minecraft.leather_chestplate": "Petu de cueru",
  "item.minecraft.leather_helmet": "Gorru de cueru",
  "item.minecraft.leather_horse_armor": "Armaúra de caballu de cueru",
  "item.minecraft.leather_leggings": "Pantalonis de cueru",
  "item.minecraft.light_blue_bundle": "Sacu azul claru",
  "item.minecraft.light_blue_dye": "Tinti azul claru",
  "item.minecraft.light_blue_harness": "Arnés azul claru",
  "item.minecraft.light_gray_bundle": "Sacu pedrés claru",
  "item.minecraft.light_gray_dye": "Tinti pedrés claru",
  "item.minecraft.light_gray_harness": "Arnés pedrés claru",
  "item.minecraft.lime_bundle": "Sacu verdi lima",
  "item.minecraft.lime_dye": "Tinti verdi lima",
  "item.minecraft.lime_harness": "Arnés verdi lima",
  "item.minecraft.lingering_potion": "Berbaju persistenti",
  "item.minecraft.lingering_potion.effect.awkward": "Berbaju raru persistenti",
  "item.minecraft.lingering_potion.effect.empty": "Berbaju persistenti nu jabricabli",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Berbaju de cuerpu inífugu persistenti",
  "item.minecraft.lingering_potion.effect.harming": "Berbaju de dañu persistenti",
  "item.minecraft.lingering_potion.effect.healing": "Berbaju de curación persistenti",
  "item.minecraft.lingering_potion.effect.infested": "Berbaju d'infistación persistenti",
  "item.minecraft.lingering_potion.effect.invisibility": "Berbaju d'invisibilidá persistenti",
  "item.minecraft.lingering_potion.effect.leaping": "Berbaju de blincu persistenti",
  "item.minecraft.lingering_potion.effect.levitation": "Berbaju de livitación persistenti",
  "item.minecraft.lingering_potion.effect.luck": "Berbaju de suerti persistenti",
  "item.minecraft.lingering_potion.effect.mundane": "Berbaju vulgar persistenti",
  "item.minecraft.lingering_potion.effect.night_vision": "Berbaju de visión de nochi persistenti",
  "item.minecraft.lingering_potion.effect.oozing": "Berbaju de mucosidá persistenti",
  "item.minecraft.lingering_potion.effect.poison": "Berbaju de venenu persistenti",
  "item.minecraft.lingering_potion.effect.regeneration": "Berbaju de riginiración persistenti",
  "item.minecraft.lingering_potion.effect.slow_falling": "Berbaju de caía lenta persistenti",
  "item.minecraft.lingering_potion.effect.slowness": "Berbaju de lintitú persistenti",
  "item.minecraft.lingering_potion.effect.strength": "Berbaju de juerza persistenti",
  "item.minecraft.lingering_potion.effect.swiftness": "Berbaju de rapidé persistenti",
  "item.minecraft.lingering_potion.effect.thick": "Berbaju densu persistenti",
  "item.minecraft.lingering_potion.effect.turtle_master": "Berbaju del maestru turtúa persistenti",
  "item.minecraft.lingering_potion.effect.water": "Frascu con augua persistenti",
  "item.minecraft.lingering_potion.effect.water_breathing": "Berbaju d'alendación baju l'augua",
  "item.minecraft.lingering_potion.effect.weakness": "Berbaju de debilidá persistenti",
  "item.minecraft.lingering_potion.effect.weaving": "Berbaju de tijiúra persistenti",
  "item.minecraft.lingering_potion.effect.wind_charged": "Berbaju de cierzu persistenti",
  "item.minecraft.llama_spawn_egg": "Güevu generaor de llama",
  "item.minecraft.lodestone_compass": "Brújula imantáa",
  "item.minecraft.mace": "Mazu",
  "item.minecraft.magenta_bundle": "Sacu magenta",
  "item.minecraft.magenta_dye": "Tinti magenta",
  "item.minecraft.magenta_harness": "Arnés magenta",
  "item.minecraft.magma_cream": "Crema de magma",
  "item.minecraft.magma_cube_spawn_egg": "Güevu generaor de cubu de magma",
  "item.minecraft.mangrove_boat": "Barcu de mangli",
  "item.minecraft.mangrove_chest_boat": "Barcu de mangli con baúl",
  "item.minecraft.map": "Mapa en brancu",
  "item.minecraft.melon_seeds": "Simienti de sandía",
  "item.minecraft.melon_slice": "Rodaja de sandía",
  "item.minecraft.milk_bucket": "Calderu con lechi",
  "item.minecraft.minecart": "Vagoneta",
  "item.minecraft.miner_pottery_shard": "Cachu de barru de picu",
  "item.minecraft.miner_pottery_sherd": "Cachu de barru de picu",
  "item.minecraft.mojang_banner_pattern": "Diseñu d'estandarti",
  "item.minecraft.mojang_banner_pattern.desc": "Estampáu de Mojang",
  "item.minecraft.mojang_banner_pattern.new": "Estampáu de Mojang",
  "item.minecraft.mooshroom_spawn_egg": "Güevu generaor de vacajongu",
  "item.minecraft.mourner_pottery_shard": "Cachu de barru de warden",
  "item.minecraft.mourner_pottery_sherd": "Cachu de barru de warden",
  "item.minecraft.mule_spawn_egg": "Güevu generaor de mula",
  "item.minecraft.mushroom_stew": "Cucíu de jongos",
  "item.minecraft.music_disc_11": "Discu de música",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Discu de música",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Discu de música",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Discu de música",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Discu de música",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Discu de música",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Discu de música",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Discu de música",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (caja de música)",
  "item.minecraft.music_disc_far": "Discu de música",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Discu de música",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Discu de música",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Discu de música",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Discu de música",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Discu de música",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Discu de música",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Discu de música",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Discu de música",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Discu de música",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Discu de música",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Discu de música",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Discu de música",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Corderu crudu",
  "item.minecraft.name_tag": "Etiqueta de llamatu",
  "item.minecraft.nautilus_shell": "Cascavija de nautilu",
  "item.minecraft.nautilus_spawn_egg": "Güevu generaor de nautilu",
  "item.minecraft.nether_brick": "Ladrillu del Nether",
  "item.minecraft.nether_star": "Estrella del Nether",
  "item.minecraft.nether_wart": "Virruga del Nether",
  "item.minecraft.netherite_axe": "Jacha de netherita",
  "item.minecraft.netherite_boots": "Botas de netherita",
  "item.minecraft.netherite_chestplate": "Petu de netherita",
  "item.minecraft.netherite_helmet": "Cascu de netherita",
  "item.minecraft.netherite_hoe": "Cesoria de netherita",
  "item.minecraft.netherite_horse_armor": "Armaúra de netherita pa caballu",
  "item.minecraft.netherite_ingot": "Lingoti de netherita",
  "item.minecraft.netherite_leggings": "Pantalonis de netherita",
  "item.minecraft.netherite_nautilus_armor": "Armaúra de netherita pa nautilu",
  "item.minecraft.netherite_pickaxe": "Picu de netherita",
  "item.minecraft.netherite_scrap": "Framentu de netherita",
  "item.minecraft.netherite_shovel": "Tul de netherita",
  "item.minecraft.netherite_spear": "Lanza de netherita",
  "item.minecraft.netherite_sword": "Espada de netherita",
  "item.minecraft.netherite_upgrade_smithing_template": "Moldi de jirriría",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Mejora de netherita",
  "item.minecraft.oak_boat": "Barcu de cajiga",
  "item.minecraft.oak_chest_boat": "Barcu de cajiga con baúl",
  "item.minecraft.ocelot_spawn_egg": "Güevu generaor d'oceloti",
  "item.minecraft.ominous_bottle": "Frascu ominosu",
  "item.minecraft.ominous_trial_key": "Llavi de disafíu ominosa",
  "item.minecraft.orange_bundle": "Sacu naranja",
  "item.minecraft.orange_dye": "Tinti naranja",
  "item.minecraft.orange_harness": "Arnés naranja",
  "item.minecraft.painting": "Cuadru",
  "item.minecraft.pale_oak_boat": "Barcu de cajiga desculuríu",
  "item.minecraft.pale_oak_chest_boat": "Barcu de cajiga esculuríu con baúl",
  "item.minecraft.panda_spawn_egg": "Güevu generaor de panda",
  "item.minecraft.paper": "Papel",
  "item.minecraft.parched_spawn_egg": "Güevu generaor de desiquíu",
  "item.minecraft.parrot_spawn_egg": "Güevu generaor de loru",
  "item.minecraft.phantom_membrane": "Membrana de pantasma",
  "item.minecraft.phantom_spawn_egg": "Güevu generaor de pantasma",
  "item.minecraft.pig_spawn_egg": "Güevu generaor de chon",
  "item.minecraft.piglin_banner_pattern": "Diseñu d'estandarti",
  "item.minecraft.piglin_banner_pattern.desc": "Estampáu de jucicu",
  "item.minecraft.piglin_banner_pattern.new": "Estampáu de jucicu",
  "item.minecraft.piglin_brute_spawn_egg": "Güevu generaor de piglin brutu",
  "item.minecraft.piglin_spawn_egg": "Güevu generaor de piglin",
  "item.minecraft.pillager_spawn_egg": "Güevu generaor de saqueaor",
  "item.minecraft.pink_bundle": "Sacu rosa",
  "item.minecraft.pink_dye": "Tinti rosa",
  "item.minecraft.pink_harness": "Arnés rosa",
  "item.minecraft.pitcher_plant": "Planta odri",
  "item.minecraft.pitcher_pod": "Vaina de planta odri",
  "item.minecraft.plenty_pottery_shard": "Cachu de barru de baúl",
  "item.minecraft.plenty_pottery_sherd": "Cachu de barru de baúl",
  "item.minecraft.poisonous_potato": "Patata venenosa",
  "item.minecraft.polar_bear_spawn_egg": "Güevu generaor d'osu polar",
  "item.minecraft.popped_chorus_fruit": "Fruta coral jorneáa",
  "item.minecraft.porkchop": "Chumarru crudu",
  "item.minecraft.potato": "Patata",
  "item.minecraft.potion": "Berbaju",
  "item.minecraft.potion.effect.awkward": "Berbaju raru",
  "item.minecraft.potion.effect.empty": "Berbaju nu jabricabli",
  "item.minecraft.potion.effect.fire_resistance": "Berbaju de cuerpu inífugu",
  "item.minecraft.potion.effect.harming": "Berbaju de dañu",
  "item.minecraft.potion.effect.healing": "Berbaju de curación",
  "item.minecraft.potion.effect.infested": "Berbaju d'infestación",
  "item.minecraft.potion.effect.invisibility": "Berbaju d'invisibilidá",
  "item.minecraft.potion.effect.leaping": "Berbaju de blincu",
  "item.minecraft.potion.effect.levitation": "Berbaju de livitación",
  "item.minecraft.potion.effect.luck": "Berbaju de suerti",
  "item.minecraft.potion.effect.mundane": "Berbaju vulgar",
  "item.minecraft.potion.effect.night_vision": "Berbaju de visión de nochi",
  "item.minecraft.potion.effect.oozing": "Berbaju de mucosidá",
  "item.minecraft.potion.effect.poison": "Berbaju de venenu",
  "item.minecraft.potion.effect.regeneration": "Berbaju de riginiración",
  "item.minecraft.potion.effect.slow_falling": "Berbaju de caía lenta",
  "item.minecraft.potion.effect.slowness": "Berbaju de lintitú",
  "item.minecraft.potion.effect.strength": "Berbaju de juerza",
  "item.minecraft.potion.effect.swiftness": "Berbaju de rapidez",
  "item.minecraft.potion.effect.thick": "Berbaju densu",
  "item.minecraft.potion.effect.turtle_master": "Berbaju del maestru turtúa",
  "item.minecraft.potion.effect.water": "Frascu con augua",
  "item.minecraft.potion.effect.water_breathing": "Berbaju de alendación baju l'augua",
  "item.minecraft.potion.effect.weakness": "Berbaju de debilidá",
  "item.minecraft.potion.effect.weaving": "Berbaju de tijiúra",
  "item.minecraft.potion.effect.wind_charged": "Berbaju de cierzu",
  "item.minecraft.pottery_shard_archer": "Cachu de barru d'arcu",
  "item.minecraft.pottery_shard_arms_up": "Cachu de barru de monigoti",
  "item.minecraft.pottery_shard_prize": "Cachu de barru de gema",
  "item.minecraft.pottery_shard_skull": "Cachu de barru de crañu",
  "item.minecraft.powder_snow_bucket": "Calderu con ñevi en polvu",
  "item.minecraft.prismarine_crystals": "Cristalis de prismarina",
  "item.minecraft.prismarine_shard": "Fragmentu de prismarina",
  "item.minecraft.prize_pottery_shard": "Cachu de barru de gema",
  "item.minecraft.prize_pottery_sherd": "Cachu de barru de gema",
  "item.minecraft.pufferfish": "Peji globu",
  "item.minecraft.pufferfish_bucket": "Calderu con peji globu",
  "item.minecraft.pufferfish_spawn_egg": "Güevu generaor de peji globu",
  "item.minecraft.pumpkin_pie": "Tarta de calabaza",
  "item.minecraft.pumpkin_seeds": "Simienti de calabaza",
  "item.minecraft.purple_bundle": "Sacu moráu",
  "item.minecraft.purple_dye": "Tinti moráu",
  "item.minecraft.purple_harness": "Arnés moráu",
  "item.minecraft.quartz": "Cuarzu del Nether",
  "item.minecraft.rabbit": "Lapín crudu",
  "item.minecraft.rabbit_foot": "Pata de lapín",
  "item.minecraft.rabbit_hide": "Pelleju de lapín",
  "item.minecraft.rabbit_spawn_egg": "Güevu generaor de lapín",
  "item.minecraft.rabbit_stew": "Cucíu de lapín",
  "item.minecraft.raiser_armor_trim_smithing_template": "Moldi de jirriría",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Diseñu d'armaúra d'ilivación",
  "item.minecraft.ravager_spawn_egg": "Güevu generaor de devastaor",
  "item.minecraft.raw_copper": "Cobri brutu",
  "item.minecraft.raw_gold": "Oru brutu",
  "item.minecraft.raw_iron": "Jierru brutu",
  "item.minecraft.recovery_compass": "Brújula de ricupiración",
  "item.minecraft.red_bundle": "Sacu encarnáu",
  "item.minecraft.red_dye": "Tinti encarnáu",
  "item.minecraft.red_harness": "Arnés encarnáu",
  "item.minecraft.redstone": "Polvu de redstone",
  "item.minecraft.resin_brick": "Ladrillu de risina",
  "item.minecraft.resin_clump": "Mazacoti de risina",
  "item.minecraft.rib_armor_trim_smithing_template": "Moldi de jirriría",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Diseñu d'armaúra de costillas",
  "item.minecraft.rotten_flesh": "Carni podri",
  "item.minecraft.saddle": "Muntura",
  "item.minecraft.salmon": "Salmón crudu",
  "item.minecraft.salmon_bucket": "Calderu con salmón",
  "item.minecraft.salmon_spawn_egg": "Güevu generaor de salmón",
  "item.minecraft.scrape_pottery_sherd": "Cachu de barru de jacha",
  "item.minecraft.scute": "Escata",
  "item.minecraft.sentry_armor_trim_smithing_template": "Moldi de jirriría",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Diseñu d'armaúra de centinela",
  "item.minecraft.shaper_armor_trim_smithing_template": "Moldi de jirriría",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Diseñu d'armaúra de modelaor",
  "item.minecraft.sheaf_pottery_shard": "Cachu de barru de paja",
  "item.minecraft.sheaf_pottery_sherd": "Cachu de barru de paja",
  "item.minecraft.shears": "Tijera",
  "item.minecraft.sheep_spawn_egg": "Güevu generaor d'uveja",
  "item.minecraft.shelter_pottery_shard": "Cachu de barru de rifugiu",
  "item.minecraft.shelter_pottery_sherd": "Cachu de barru de rifugiu",
  "item.minecraft.shield": "Iscudu",
  "item.minecraft.shield.black": "Iscudu negru",
  "item.minecraft.shield.blue": "Iscudu azul",
  "item.minecraft.shield.brown": "Iscudu pardu",
  "item.minecraft.shield.cyan": "Iscudu cian",
  "item.minecraft.shield.gray": "Iscudu pedrés",
  "item.minecraft.shield.green": "Iscudu verdi",
  "item.minecraft.shield.light_blue": "Iscudu azul claru",
  "item.minecraft.shield.light_gray": "Iscudu pedrés claru",
  "item.minecraft.shield.lime": "Iscudu verdi lima",
  "item.minecraft.shield.magenta": "Iscudu magenta",
  "item.minecraft.shield.orange": "Iscudu naranja",
  "item.minecraft.shield.pink": "Iscudu rosa",
  "item.minecraft.shield.purple": "Iscudu moráu",
  "item.minecraft.shield.red": "Iscudu encarnáu",
  "item.minecraft.shield.white": "Iscudu brancu",
  "item.minecraft.shield.yellow": "Iscudu amarillu",
  "item.minecraft.shulker_shell": "Caparazón de shulker",
  "item.minecraft.shulker_spawn_egg": "Güevu generaor de shulker",
  "item.minecraft.sign": "Firmar",
  "item.minecraft.silence_armor_trim_smithing_template": "Moldi de jirriría",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Diseñu d'armaúra de silenciu",
  "item.minecraft.silverfish_spawn_egg": "Güevu generaor de lipisma",
  "item.minecraft.skeleton_horse_spawn_egg": "Güevu generaor de caballu esqueletu",
  "item.minecraft.skeleton_spawn_egg": "Güevu generaor d'esqueletu",
  "item.minecraft.skull_banner_pattern": "Diseñu d'estandarti",
  "item.minecraft.skull_banner_pattern.desc": "Estampáu de crañu",
  "item.minecraft.skull_banner_pattern.new": "Estampáu de crañu",
  "item.minecraft.skull_pottery_shard": "Cachu de barru de crañu",
  "item.minecraft.skull_pottery_sherd": "Cachu de barru de crañu",
  "item.minecraft.slime_ball": "Bola de slime",
  "item.minecraft.slime_spawn_egg": "Güevu generaor de slime",
  "item.minecraft.smithing_template": "Moldi de jirriría",
  "item.minecraft.smithing_template.applies_to": "Aplícasi a:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Añidi un lingoti o cristal",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Armaúras",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Añidi una pieza d'armaúra",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Lingotis y cristalis",
  "item.minecraft.smithing_template.ingredients": "Ingridientis:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Añidi un lingoti de netherita",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Iquipamientu de diamanti",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Añidi una armaúra, arma o jarramienta de diamanti",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Lingoti de netherita",
  "item.minecraft.smithing_template.upgrade": "Mejora:",
  "item.minecraft.sniffer_spawn_egg": "Güevu generaor de sniffer",
  "item.minecraft.snort_pottery_shard": "Cachu de barru de sniffer",
  "item.minecraft.snort_pottery_sherd": "Cachu de barru de sniffer",
  "item.minecraft.snout_armor_trim_smithing_template": "Moldi de jirriría",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Diseñu d'armaúra de jucicu",
  "item.minecraft.snow_golem_spawn_egg": "Güevu generaor de gólem de ñevi",
  "item.minecraft.snowball": "Bola de ñevi",
  "item.minecraft.spectral_arrow": "Flecha espetral",
  "item.minecraft.spider_eye": "Lámparu d'araña",
  "item.minecraft.spider_spawn_egg": "Güevu generaor d'araña",
  "item.minecraft.spire_armor_trim_smithing_template": "Moldi de jirriría",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Diseñu d'armaúra d'abujas",
  "item.minecraft.splash_potion": "Berbaju arrujaízu",
  "item.minecraft.splash_potion.effect.awkward": "Berbaju raru arrujaízu",
  "item.minecraft.splash_potion.effect.empty": "Berbaju arrujaízu nu jabricabli",
  "item.minecraft.splash_potion.effect.fire_resistance": "Berbaju de cuerpu ignífugu arrujaízu",
  "item.minecraft.splash_potion.effect.harming": "Berbaju de dañu arrujaízu",
  "item.minecraft.splash_potion.effect.healing": "Berbaju de curación arrujaízu",
  "item.minecraft.splash_potion.effect.infested": "Berbaju d'infistación arrujaízu",
  "item.minecraft.splash_potion.effect.invisibility": "Berbaju d'invisibilidá arrujaízu",
  "item.minecraft.splash_potion.effect.leaping": "Berbaju de blincu arrujaízu",
  "item.minecraft.splash_potion.effect.levitation": "Berbaju de livitación arrujaízu",
  "item.minecraft.splash_potion.effect.luck": "Berbaju de suerti arrujaízu",
  "item.minecraft.splash_potion.effect.mundane": "Berbaju vulgar arrujaízu",
  "item.minecraft.splash_potion.effect.night_vision": "Berbaju de visión de nochi arrujaízu",
  "item.minecraft.splash_potion.effect.oozing": "Berbaju de mucosidá arrojaízu",
  "item.minecraft.splash_potion.effect.poison": "Berbaju de venenu arrujaízu",
  "item.minecraft.splash_potion.effect.regeneration": "Berbaju de riginiración arrujaízu",
  "item.minecraft.splash_potion.effect.slow_falling": "Berbaju de caía lenta arrujaízu",
  "item.minecraft.splash_potion.effect.slowness": "Berbaju de lintitú arrujaízu",
  "item.minecraft.splash_potion.effect.strength": "Berbaju de juerza arrujaízu",
  "item.minecraft.splash_potion.effect.swiftness": "Berbaju de rapidez arrujaízu",
  "item.minecraft.splash_potion.effect.thick": "Berbaju densu arrujaízu",
  "item.minecraft.splash_potion.effect.turtle_master": "Berbaju del maestru turtúa arrujaízu",
  "item.minecraft.splash_potion.effect.water": "Frascu con augua arrujaízu",
  "item.minecraft.splash_potion.effect.water_breathing": "Berbaju de alendación baju l'augua arrojaízu",
  "item.minecraft.splash_potion.effect.weakness": "Berbaju de debilidá arrujaízu",
  "item.minecraft.splash_potion.effect.weaving": "Berbaju de tijiúra arrujaízu",
  "item.minecraft.splash_potion.effect.wind_charged": "Berbaju de cierzu arrujaízu",
  "item.minecraft.spruce_boat": "Barcu d'abetu",
  "item.minecraft.spruce_chest_boat": "Barcu d'abetu con baúl",
  "item.minecraft.spyglass": "Cataleju",
  "item.minecraft.squid_spawn_egg": "Güevu generaor de maganu",
  "item.minecraft.stick": "Palu",
  "item.minecraft.stone_axe": "Jacha de cantu",
  "item.minecraft.stone_hoe": "Cesoria de cantu",
  "item.minecraft.stone_pickaxe": "Picu de cantu",
  "item.minecraft.stone_shovel": "Tul de cantu",
  "item.minecraft.stone_spear": "Lanza de cantu",
  "item.minecraft.stone_sword": "Espada de cantu",
  "item.minecraft.stray_spawn_egg": "Güevu generaor d'erranti",
  "item.minecraft.strider_spawn_egg": "Güevu generaor de lavaganti",
  "item.minecraft.string": "Jilu",
  "item.minecraft.sugar": "Azúcara",
  "item.minecraft.suspicious_stew": "Cucíu sospechosu",
  "item.minecraft.sweet_berries": "Ráspanos dulcis",
  "item.minecraft.tadpole_bucket": "Calderu con chambergu",
  "item.minecraft.tadpole_spawn_egg": "Güevu generaor de chambergu",
  "item.minecraft.tide_armor_trim_smithing_template": "Moldi de jirriría",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Diseñu d'armaúra de la marea",
  "item.minecraft.tipped_arrow": "Flecha con efeutu",
  "item.minecraft.tipped_arrow.effect.awkward": "Flecha con augua raru",
  "item.minecraft.tipped_arrow.effect.empty": "Flecha con efeutu nu jabricabli",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Flecha de cuerpu ignífugu",
  "item.minecraft.tipped_arrow.effect.harming": "Flecha de dañu",
  "item.minecraft.tipped_arrow.effect.healing": "Flecha de curación",
  "item.minecraft.tipped_arrow.effect.infested": "Flecha d'infistación",
  "item.minecraft.tipped_arrow.effect.invisibility": "Flecha d'invisibilidá",
  "item.minecraft.tipped_arrow.effect.leaping": "Flecha de blincu",
  "item.minecraft.tipped_arrow.effect.levitation": "Flecha de livitación",
  "item.minecraft.tipped_arrow.effect.luck": "Flecha de suerti",
  "item.minecraft.tipped_arrow.effect.mundane": "Flecha con efeutu",
  "item.minecraft.tipped_arrow.effect.night_vision": "Flecha de visión de nochi",
  "item.minecraft.tipped_arrow.effect.oozing": "Flecha de mucosidá",
  "item.minecraft.tipped_arrow.effect.poison": "Flecha de venenu",
  "item.minecraft.tipped_arrow.effect.regeneration": "Flecha de riginiración",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Flecha de caía lenta",
  "item.minecraft.tipped_arrow.effect.slowness": "Flecha de lintitú",
  "item.minecraft.tipped_arrow.effect.strength": "Flecha de juerza",
  "item.minecraft.tipped_arrow.effect.swiftness": "Flecha de rapidez",
  "item.minecraft.tipped_arrow.effect.thick": "Flecha con augua densu",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Flecha del maestru turtúa",
  "item.minecraft.tipped_arrow.effect.water": "Flecha de salpicatu",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Flecha d'alendación baju l'augua",
  "item.minecraft.tipped_arrow.effect.weakness": "Flecha de debilidá",
  "item.minecraft.tipped_arrow.effect.weaving": "Flecha de tijiúra",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Flecha de cierzu",
  "item.minecraft.tnt_minecart": "Vagoneta con dinamita",
  "item.minecraft.torchflower_seeds": "Simienti de plantaja",
  "item.minecraft.totem_of_undying": "Tótem d'inmortalidá",
  "item.minecraft.trader_llama_spawn_egg": "Güevu generaor de llama ambulanti",
  "item.minecraft.trial_key": "Llavi de disafíu",
  "item.minecraft.trident": "Trenti",
  "item.minecraft.tropical_fish": "Peji tropical",
  "item.minecraft.tropical_fish_bucket": "Calderu con peji tropical",
  "item.minecraft.tropical_fish_spawn_egg": "Güevu generaor de peji tropical",
  "item.minecraft.turtle_helmet": "Cascavija de turtúa",
  "item.minecraft.turtle_scute": "Escata de turtúa",
  "item.minecraft.turtle_spawn_egg": "Güevu generaor de turtúa",
  "item.minecraft.vex_armor_trim_smithing_template": "Moldi de jirriría",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Diseñu d'armaúra de vex",
  "item.minecraft.vex_spawn_egg": "Güevu generaor de vex",
  "item.minecraft.villager_spawn_egg": "Güevu generaor d'aldeanu",
  "item.minecraft.vindicator_spawn_egg": "Güevu generaor de vindicaor",
  "item.minecraft.wandering_trader_spawn_egg": "Güevu generaor de vendeor ambulanti",
  "item.minecraft.ward_armor_trim_smithing_template": "Moldi de jirriría",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Diseñu d'armaúra de warden",
  "item.minecraft.warden_spawn_egg": "Güevu generaor de warden",
  "item.minecraft.warped_fungus_on_a_stick": "Caña con seta distorsionáa",
  "item.minecraft.water_bucket": "Calderu con augua",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Moldi de jirriría",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Diseñu d'armaúra buscacaminos",
  "item.minecraft.wheat": "Trigu",
  "item.minecraft.wheat_seeds": "Simienti de trigu",
  "item.minecraft.white_bundle": "Sacu brancu",
  "item.minecraft.white_dye": "Tinti brancu",
  "item.minecraft.white_harness": "Arnés brancu",
  "item.minecraft.wild_armor_trim_smithing_template": "Moldi de jirriría",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Diseñu d'armaúra de salvaji",
  "item.minecraft.wind_charge": "Carga de vientu",
  "item.minecraft.witch_spawn_egg": "Güevu generaor de lumia",
  "item.minecraft.wither_skeleton_spawn_egg": "Güevu generaor d'esqueletu Wither",
  "item.minecraft.wither_spawn_egg": "Güevu generaor de Wither",
  "item.minecraft.wolf_armor": "Armaúra pa lobu",
  "item.minecraft.wolf_spawn_egg": "Güevu generaor de lobu",
  "item.minecraft.wooden_axe": "Jacha de maera",
  "item.minecraft.wooden_hoe": "Cesoria de maera",
  "item.minecraft.wooden_pickaxe": "Picu de maera",
  "item.minecraft.wooden_shovel": "Tul de maera",
  "item.minecraft.wooden_spear": "Lanza de maera",
  "item.minecraft.wooden_sword": "Espada de maera",
  "item.minecraft.writable_book": "Libru y pruma",
  "item.minecraft.written_book": "Libru iscritu",
  "item.minecraft.yellow_bundle": "Sacu amarillu",
  "item.minecraft.yellow_dye": "Tinti amarillu",
  "item.minecraft.yellow_harness": "Arnés amarillu",
  "item.minecraft.zoglin_spawn_egg": "Güevu generaor de zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Güevu generaor de caballu zombi",
  "item.minecraft.zombie_nautilus_spawn_egg": "Güevu generaor de nautilu zombi",
  "item.minecraft.zombie_spawn_egg": "Güevu generaor de zombi",
  "item.minecraft.zombie_villager_spawn_egg": "Güevu generaor d'aldeanu zombi",
  "item.minecraft.zombified_piglin_spawn_egg": "Güevu generaor de piglin zombificáu"
}
export const qcb_es = items; 
